import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Box, Button, Divider, Drawer, DrawerBody, DrawerContent, DrawerOverlay, Flex, HStack, List, ListItem, Heading, IconButton, Image, SimpleGrid, Spacer, Text, UnorderedList, VStack, useDisclosure, useMediaQuery, Switch, ListIcon, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react'
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

// Images
import HogarDownMovil from '../../Assets/HOGAR/Banner_Inferior_Mobile.webp';
import HogarDown from '../../Assets/HOGAR/Banner-Inferior-Desktop.webp';
import BannerDkDisney from '../../Assets/HOGAR/BannerDkDisney.webp';
import BannerMbDisney from '../../Assets/HOGAR/BannerMbDisney.webp';
import BannerMb from '../../Assets/HOGAR/BannerMb.webp';
import BannerDk from '../../Assets/HOGAR/BannerDk.webp';
import Canales from '../../Assets/HOGAR/90Canales.webp';
import Disney from '../../Assets/HOGAR/disney.webp';

import tntSport from '../../Assets/HOGAR/DUO/tnt-sport-premium.webp';
import BannerMbDuo from '../../Assets/HOGAR/DUO/BannerMb.webp';
import BannerDkDuo from '../../Assets/HOGAR/DUO/BannerDk.webp';
import EntelTV from '../../Assets/HOGAR/DUO/EntelTV.webp';
import Youtube from '../../Assets/HOGAR/DUO/youtube.webp';
import appletv from '../../Assets/HOGAR/DUO/appletv.webp';
import Canales46 from '../../Assets/HOGAR/46Canales.webp';
import tntHbo from '../../Assets/HOGAR/DUO/tnt-hbo.webp';
import Fantiz from '../../Assets/HOGAR/fantiz.webp';
import Max from '../../Assets/HOGAR/DUO/max.webp';

// Icons
import { IconChat, IconComunidad, IconCorazon, IconDatos, IconExtensor, IconGamer, IconHogarNew, IconNube, IconRouter, IconSeguridad, IconSimetrica, IconTecnico, IconTv, IconUnion, IconUsuarios, IconHogarDuo, IconTvEntel, Icon24Hrs, IconSenal, IconCanalPremium, IconEquipoEntel, IconVelocidad, IconTntSport, IconRayo, IconDeco, IconAudio, IconCrispetas, IconMensajes, IconHogarSencillo, IconMaleta, IconTvMobile, IconTicket } from '../../Assets/HOGAR/Icons';
import { IconArrowDown, IconArrowRight, IconArrowUp, IconEjecutivo, IconEquipo, IconHogar, IconInfo, OfertaFlash } from '../../Assets/GENERALES/Icons';
import { AiOutlineClose } from 'react-icons/ai';
import { BsChevronRight } from "react-icons/bs";

// Components
import SlideModal from '../../Components/Slide/SlideModal';
import enviroments from '../../Services/enviroments';

// Styles
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/skyblue';
import './style.css';

const Hogar = () => {
    const { tipo } = useParams();

    const [planSelectedDuo, setPlanSelectedDuo] = useState(localStorage.getItem('planSelectedDuo') ? parseInt(localStorage.getItem('planSelectedDuo')) : 1);
    const [planSelected, setPlanSelected] = useState(localStorage.getItem('planSelected') ? parseInt(localStorage.getItem('planSelected')) : 1);
    const [timeRemaining, setTimeRemaining] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [precioNormalSolicitado, setPrecioNormalSolicitado] = useState('');
    const [precioSolicitada, setPrecioSolicitada] = useState('');
    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [dataPlanDrawer, setDataPlanDrawer] = useState({});
    const [planSolicitada, setPlanSolicitada] = useState('');
    const [descuentoPlan, setDescuentoPlan] = useState('');
    const [seccionView, setSeccionView] = useState(tipo);
    const [indexDrawer, setIndexDrawer] = useState();
    const [dataDrawer, setDataDrawer] = useState({});
    const [isBanner, setIsBanner] = useState(false);
    const [typePlan, setTypePlan] = useState('');
    const [namePlan, setNamePlan] = useState('');
    const [id, setId] = useState('');
    const [planTypeSelect, setPlanTypeSelect] = useState('full');

    const [isMobile] = useMediaQuery("(max-width: 768px)");

    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    let campaignid = urlParams.get('campaignid');
    let adgroupid = urlParams.get('adgroupid');
    let anuncioGroup = urlParams.get('group');
    let keyword = urlParams.get('keyword');
    let origen = urlParams.get('origin');
    let gclid = urlParams.get('gclid');
    let adId = urlParams.get('adId');
    let type = urlParams.get('type');

    const navigate = useNavigate();

    const { onOpen, isOpen, onClose } = useDisclosure();

    const planesHogar = [
        {
            id: 1,
            descripcion: 'Sin Disney+',
            planes: [
                {
                    id: 1,
                    plan: 'Fibra 600',
                    megas: '600',
                    destacado: 0,
                    especial: 6,
                    disney: false,
                    nuevo: 0,
                    icon: '',
                    router: 'Router',
                    dcto: '22%',
                    precio: '$17.990',
                    luego: 'Precio normal: $22.990/mes',
                    timeOffer: '12 meses',
                    ciberDestacado:false,
                    items: [
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>8 dispositivos</b>`
                        },
                        {
                            id: 4,
                            icon: <IconVelocidad color='#002EFF' />,
                            info: `Velocidad <b>máxima 600Mbps y mínima garantizada 50 Mbps.</b> <u style="color: #002EFF">Conocer más</u>`
                        },
                    ]
                },
                {
                    id: 2,
                    plan: 'Fibra 800',
                    megas: '800',
                    disney: false,
                    destacado: 1,
                    especial: 6,
                    extra: '+ Extensor',
                    nuevo: 0,
                    icon: '',
                    router: 'Router + Hasta 1 Extensor',
                    dcto: '27%',
                    precio: '$18.990',
                    luego: 'Precio normal: $25.990/mes',
                    timeOffer: '12 meses',
                    ciberDestacado:false,
                    items: [
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>16 dispositivos</b>`
                        },
                        {
                            id: 3,
                            icon: <IconRouter color='#002EFF' />,
                            info: `Incluiye <b>Router WiFi 6</b>`
                        },
                        {
                            id: 4,
                            icon: <IconVelocidad color='#002EFF' />,
                            info: `Velocidad <b>máxima 800Mbps y mínima garantizada 50 Mbps.</b>`
                        },
                    ]
                },
                {
                    id: 3,
                    plan: 'Fibra Giga',
                    megas: '940',
                    destacado: 0,
                    especial: 7,
                    extra: '+ Extensor',
                    disney: false,
                    nuevo: 0,
                    icon: '',
                    router: 'Router + Hasta 1 Extensores',
                    dcto: '32%',
                    precio: '$22.990',
                    luego: 'Precio normal: $33.990/mes',
                    timeOffer: '12 meses',
                    ciberDestacado:false,
                    items: [
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>30 dispositivos</b>`
                        },
                        {
                            id: 3,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `<b>Hasta 1 extensor WiFi 7</b> según evaluación técnica`
                        },
                        {
                            id: 4,
                            icon: <IconVelocidad color='#002EFF' />,
                            info: `Velocidad <b>máxima 940Mbps y mínima garantizada 50Mbps.</b> <u style="color: #002EFF">Conocer más</u>`
                        },
                    ]
                },
                {
                    id: 4,
                    plan: 'Fibra 2 Giga',
                    megas: '2.000',
                    destacado: 0,
                    especial: 7,
                    extra: '+ Extensor',
                    disney: false,
                    nuevo: 0,
                    icon: '',
                    router: 'Router + Hasta 1 Extensores',
                    dcto: '25%',
                    precio: '$29.990',
                    luego: 'Precio normal: $39.990/mes',
                    timeOffer: '12 meses',
                    items: [
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>50 dispositivos</b>`
                        },
                        {
                            id: 3,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `<b>Hasta 1 extensor WiFi 7</b> según evaluación técnica`
                        },
                        {
                            id: 4,
                            icon: <IconVelocidad color='#002EFF' />,
                            info: `Velocidad <b>máxima 2.000Mbps y mínima garantizada 50Mbps</b> <u style="color: #002EFF">Conocer más</u>`
                        },
                    ]
                },
            ]
        },
        {
            id: 2,
            descripcion: 'Con Disney+',
            planes: [
                {
                    id: 1,
                    plan: 'Fibra 600+',
                    megas: '600',
                    destacado: 0,
                    especial: 6,
                    disney: true,
                    nuevo: 0,
                    icon: '',
                    router: 'Router',
                    dcto: '13%',
                    precio: '$26.990',
                    luego: 'Precio normal: $30.990/mes',
                    timeOffer: '12 meses',
                    items: [
                        {
                            id: 2,
                            icon: <IconTvMobile color='#002EFF' />,
                            info: `Conecta hasta <b>8 dispositivos</b>`
                        },
                        {
                            id: 3,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `No incluye extensor<br/>‎`
                        },
                        {
                            id: 4,
                            icon: <IconVelocidad color='#002EFF' />,
                            info: `Velocidad <b>máxima 600Mbps.</b> <u style="color: #002EFF">Conocer más</u>`
                        },
                    ]
                },
                {
                    id: 2,
                    plan: 'Fibra 800+',
                    megas: '800',
                    destacado: 0,
                    especial: 6,
                    extra: '+ Extensor',
                    disney: true,
                    nuevo: 0,
                    icon: '',
                    router: 'Router + Hasta 1 Extensor',
                    dcto: '13%',
                    precio: '$27.990',
                    luego: 'Precio normal: $31.990/mes',
                    timeOffer: '12 meses',
                    items: [
                        {
                            id: 2,
                            icon: <IconTvMobile color='#002EFF' />,
                            info: `Conecta hasta <b>16 dispositivos</b>`
                        },
                        {
                            id: 3,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `<b>Hasta 1 extensor WiFi 6</b> según evaluación técnica`
                        },
                        {
                            id: 4,
                            icon: <IconVelocidad color='#002EFF' />,
                            info: `Velocidad <b>máxima 800Mbps.</b>`
                        },
                    ]
                },
                {
                    id: 3,
                    plan: 'Fibra Giga+',
                    megas: '940',
                    destacado: 0,
                    disney: true,
                    nuevo: 0,
                    especial: 7,
                    extra: '+ Extensor',
                    icon: '',
                    router: 'Router + Hasta 1 Extensores',
                    dcto: '26%',
                    precio: '$28.990',
                    luego: 'Precio normal: $38.990/mes',
                    timeOffer: '12 meses',
                    items: [
                        {
                            id: 2,
                            icon: <IconTvMobile color='#002EFF' />,
                            info: `Conecta hasta <b>30 dispositivos</b>`
                        },
                        {
                            id: 3,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `<b>Hasta 1 extensor WiFi 7</b> según evaluación técnica`
                        },
                        {
                            id: 4,
                            icon: <IconVelocidad color='#002EFF' />,
                            info: `Velocidad <b>máxima 940Mbps.</b> <u style="color: #002EFF">Conocer más</u>`
                        },
                    ]
                },
            ]
        },
    ];

    const planesHogarDuo = [
        {
            id: 1,
            cantidad: '<b>600 Megas</b>',
            desde: '- Desde $28.990',
            planes: [
                {
                    id: 1,
                    id2: 11,
                    megas: '600',
                    plan: 'Fibra 600 TV Full+',
                    planType: 'full',
                    destacado: 0,
                    nuevo: 0,
                    especial: 6,
                    icon: '',
                    name: '',
                    description: '',
                    incluyeDos: Youtube,
                    incluyeUno: Disney,
                    incluyeCero: appletv,
                    incluyeCuatro: Fantiz,
                    incluyeQuinto: EntelTV,
                    incluyeTres: Max,
                    incluyeSeis: Canales,
                    dcto: '29%',
                    precio: '$34.990',
                    luego: 'Precio normal: $49.490/mes',
                    precioLuego: '49490',
                    timeOffer: '12 meses',
                    ciberDestacado:false,
                    items: [
                        {
                            id: 1,
                            icon: <IconTv size='16' color='#002EFF' />,
                            info: `<b>98 Canales</b> en total`
                        },
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>8 dispositivos</b>`
                        },
                        {
                            id: 3,
                            icon: <IconVelocidad size='16' color='#002EFF' />,
                            info: `Velocidad <b>máxima 600Mbps y mínima garantizada 50Mbps.</b> <a onClick=""><u style="color: #002EFF">Conocer más</u></a>`
                        }
                    ],
                    drawer: {
                        megas: '600',
                        plan: 'TV Full+',
                        icon: <IconRouter />,
                        name: '¿Qué es WiFi 6?',
                        description: 'Tecnología que te ofrece una <b>navegación más rápida, estable y eficiente</b> incluso cuando todos están usando internet.',
                        beneficioUno: {
                            icon: <IconVelocidad size='25px' />,
                            name: 'Velocidad de navegación',
                            content: {
                                icon: <IconSimetrica size='20' />,
                                name: 'Velocidad simétrica',
                                description: 'Cuando tu plan tiene los mismos megas de subida y bajada.',
                                megas: '600 Mbps',
                                ideal: [
                                    {
                                        id: 1,
                                        icon: <IconEquipo size='25' />,
                                        name: 'Conectar hasta 7 - 8 dispositivos simultáneamente'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconSenal size='25' />,
                                        name: 'Descargar archivos rápidamente'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Trabajar y estudiar a distancia'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='25' />,
                                        name: 'Ver películas y series en HD'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconGamer size='25' />,
                                        name: 'Jugar en línea'
                                    }
                                ]
                            }
                        },
                        beneficioDos: {
                            icon: <IconTvEntel size='33' />,
                            name: 'Entel TV - TV Lite',
                            content: {
                                canales: '98 Canales en total',
                                desglose: '84 en  HD + 1 Deco Entel TV',
                                description: 'Televisión Fibra HD<br />Permite acceder a la programación de canales de cable y televisión abierta. Este plan incluye un decodificador Entel TV y puedes agregar más por $3.490/mes|',
                                info: 'Disfruta los últimos estrenos del cine, las mejores series en tu idioma y el mejor deporte del mundo en vivo.',
                                incluye: [
                                    {
                                        id: 1,
                                        icon: <IconTv size='25' />,
                                        name: 'Podrás difrutar 98 canales totales, 84 en  HD'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Sin límite de pantallas en uso simultáneo'
                                    },
                                    {
                                        id: 3,
                                        icon: <Icon24Hrs size='40' />,
                                        name: 'Vulve a ver el contenido emitido en las últimas 24 hrs y pausa tu programación favorita'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconRouter size='25' />,
                                        name: 'Incluye 1 decodificador (requiere instalación)'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconCanalPremium size='25' />,
                                        name: 'Podrás agregar canales Premium'
                                    }
                                ]
                            }
                        },
                        incluye: [
                            {
                                id: 1,
                                name: 'App <b>Max</b> y <b>Pack HBO</b> de 8 canales.'
                            },
                            {
                                id: 2,
                                name: 'Suscripción a <b>Disney+ Premium.</b>'
                            },
                            {
                                id: 7,
                                name: 'Suscripción a <b>YouTube Premium Lite.</b>'
                            },
                            {
                                id: 6,
                                name: 'Suscripción a <b>Apple TV.</b>'
                            },
                            {
                                id: 8,
                                name: 'Suscripción a <b>Fanatiz.</b>'
                            },
                            {
                                id: 3,
                                name: 'Uso de tu <b>Deco Entel TV</b> sólo dentro de tu hogar'
                            },
                            {
                                id: 4,
                                name: 'Uso de <b>App Entel TV</b> en disp. móviles <b>donde quieras</b>'
                            },
                            {
                                id: 5,
                                name: 'Uso de <b>App Entel TV</b> para Smart TV sólo dentro de tu hogar'
                            }
                        ],
                        adicionalesUno: '',
                        adicionalesDos: {
                            id: 1,
                            icon: <IconTntSport size='33' />,
                            name: 'Suscribete a <b>TNT Sports Premium por $14.590/mes</b>',
                            content: {
                                description: '<b>¡Aprovecha el primer mes sin costo!</b> Esta suscripción incluye acceso a TNT Sports Premium en la app de Max y los canales TNT Sports Premium SD y HD.',
                                logos: [
                                    {
                                        id: 1,
                                        logo: tntSport
                                    },
                                    {
                                        id: 2,
                                        logo: tntHbo
                                    }
                                ],
                                tyt: '*TNT Sports Premium sin costo por 1 mes. Solo nuevas contrataciones. (Precio nomal: $14.590)'
                            }
                        }
                    }
                },
                {
                    id: 2,
                    id2: 12,
                    megas: '600',
                    destacado: 0,
                    nuevo: 0,
                    especial: 6,
                    plan: 'Fibra 600 TV Lite+',
                    planType: 'lite',
                    incluyeUno: Disney,
                    incluyeDos: EntelTV,
                    incluyeTres: Canales46,
                    incluyeCuatro: '',
                    dcto: '29%',
                    precio: '$28.990',
                    luego: 'Precio normal: $40.990/mes',
                    precioLuego: '40990',
                    timeOffer: '12 meses',
                    items: [
                        {
                            id: 1,
                            icon: <IconTv size='16' color='#002EFF' />,
                            info: `<b>59 Canales</b> en total`
                        },
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>8 dispositivos</b>`
                        },
                        {
                            id: 4,
                            icon: <IconVelocidad size='16' color='#002EFF' />,
                            info: `Velocidad <b>máxima 600Mbps y mínima garantizada 50Mbps</b> <u style="color: #002EFF">Conocer más</u>`
                        }
                    ],
                    drawer: {
                        megas: '600',
                        plan: 'TV Lite+',
                        icon: <IconRouter />,
                        name: '¿Qué es WiFi 6?',
                        description: 'Tecnología que te ofrece una <b>navegación más rápida, estable y eficiente</b> incluso cuando todos están usando internet.',
                        beneficioUno: {
                            icon: <IconVelocidad size='25px' />,
                            name: 'Velocidad de navegación',
                            content: {
                                icon: <IconSimetrica size='20' />,
                                name: 'Velocidad simétrica',
                                description: 'Cuando tu plan tiene los mismos megas de subida y bajada.',
                                megas: '600 Mbps',
                                ideal: [
                                    {
                                        id: 1,
                                        icon: <IconEquipo size='25' />,
                                        name: 'Conectar hasta 7 - 8 dispositivos simultáneamente'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconSenal size='25' />,
                                        name: 'Descargar archivos rápidamente'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Trabajar y estudiar a distancia'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='25' />,
                                        name: 'Ver películas y series en HD'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconGamer size='25' />,
                                        name: 'Jugar en línea'
                                    }
                                ]
                            }
                        },
                        beneficioDos: {
                            icon: <IconTvEntel size='33' />,
                            name: 'Entel TV - TV Lite +',
                            content: {
                                canales: '59 Canales en total',
                                desglose: '47 en HD + 1 Deco Entel TV',
                                description: 'Vive una experiencia superior con Deco Entel TV Este plan incluye un decodificador Entel TV y puedes agregar más por $3.490/mes',
                                info: 'TV online, donde y cuando quieras TV Lite es como la televisión tradicional, pero online: ¡La señal llega por internet!',
                                incluye: [
                                    {
                                        id: 1,
                                        icon: <IconTv size='25' />,
                                        name: 'Podrás difrutar <strong style="color: #002EFF"><u>59 canales totales, 47 en HD</u></strong>'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconEquipoEntel size='25' />,
                                        name: 'Contenido disponible donde quieras con tu App Entel TV'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Hasta 2 pantallas en uso simultáneo'
                                    },
                                    {
                                        id: 4,
                                        icon: <Icon24Hrs size='40' />,
                                        name: 'Vulve a ver el contenido emitido en las últimas 24 hrs y pausa tu programación favorita'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconRouter size='25' />,
                                        name: 'incluye 1 decodificador (autoinstalable)'
                                    }
                                ]
                            }
                        },
                        incluye: [
                            {
                                id: 1,
                                name: 'Uso de App Entel TV en disp. móviles <b>donde quieras</b>'
                            },
                            {
                                id: 2,
                                name: 'Uso de Appe Entel TV en smart TV <b>donde quieras</b>'
                            },
                            {
                                id: 3,
                                name: 'Suscripción a <b>Disney + Premiun.</b>'
                            },
                        ],
                        adicionalesUno: '',
                        adicionalesDos: {
                            id: 1,
                            icon: <IconTntSport />,
                            name: 'Suscribete a <b>TNT Sports Premium por $14.590/mes</b>',
                            content: {
                                description: '<b>¡Aprovecha el primer mes sin costo!</b> Esta suscripción incluye acceso a TNT Sports Premium en la app de Max y los canales TNT Sports Premium SD yx HD.',
                                logos: [
                                    {
                                        id: 1,
                                        logo: tntSport
                                    },
                                    {
                                        id: 2,
                                        logo: tntHbo
                                    }
                                ],
                                tyt: '*TNT Sports Premium sin costo por 1 mes. Solo nuevas contrataciones. (Precio nomal: $14.590)'
                            }
                        }
                    }
                },
            ]
        },
        {
            id: 2,
            cantidad: '<b>800 Megas</b>',
            desde: '- Desde $29.990',
            planes: [
                {
                    id: 3,
                    id2: 21,
                    megas: '800',
                    destacado: 1,
                    nuevo: 0,
                    especial: 6,
                    extra: '+ Extensor',
                    plan: 'Fibra 800 TV Full+',
                    planType: 'full',
                    incluyeDos: Youtube,
                    incluyeUno: Disney,
                    incluyeCero: appletv,
                    incluyeCuatro: Fantiz,
                    incluyeQuinto: EntelTV,
                    incluyeTres: Max,
                    incluyeSeis: Canales,
                    dcto: '31%',
                    precio: '$35.990',
                    luego: 'Precio normal: $52.490/mes',
                    precioLuego: '52490',
                    timeOffer: '12 meses',
                    ciberDestacado:false,
                    items: [
                        {
                            id: 3,
                            icon: <IconTv size='16' color='#002EFF' />,
                            info: `<b>98 Canales</b> en total`
                        },
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>16 dispositivos</b>`
                        },
                        {
                            id: 5,
                            icon: <IconVelocidad size='16' color='#002EFF' />,
                            info: `Velocidad <b>máxima 800Mbps y mínima garantizada 50 Mbps.</b> <u style="color: #002EFF">Conocer más</u>`
                        },
                        {
                            id: 4,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `<b>Hasta 1 extensor WiFi 6</b> según evaluación técnica`
                        },
                    ],
                    drawer: {
                        megas: '800',
                        plan: 'TV Full+',
                        icon: <IconRouter />,
                        name: '¿Qué es WiFi 6?',
                        description: 'Tecnología que te ofrece una <b>navegación más rápida, estable y eficiente</b> incluso cuando todos están usando internet.',
                        titleWiFi: '',
                        descriptionWiFi: '',
                        beneficioUno: {
                            icon: <IconVelocidad size='25px' />,
                            name: 'Velocidad de navegación',
                            content: {
                                icon: <IconSimetrica size='20' />,
                                name: 'Velocidad simétrica',
                                description: 'Cuando tu plan tiene los mismos megas de subida y bajada.',
                                megas: '800 Mbps',
                                ideal: [
                                    {
                                        id: 1,
                                        icon: <IconEquipo size='25' />,
                                        name: 'Conectar hasta 14 - 16 dispositivos simultáneamente'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconEjecutivo color='#002EFF' size='33' />,
                                        name: 'Realizar videoconferencia. Descargar y subir archivos rápidamente'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Trabajar y estudiar a distancia'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='25' />,
                                        name: 'Ver películas y series en HD'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconGamer size='25' />,
                                        name: 'Jugar en línea <b>como profesional</b>'
                                    }
                                ]
                            }
                        },
                        beneficioDos: {
                            icon: <IconTvEntel size='33' />,
                            name: 'Entel TV - TV Lite',
                            content: {
                                canales: '98 Canales en total',
                                desglose: '84 en  HD + 1 Deco Entel TV',
                                description: 'Televisión Fibra HD<br />Permite acceder a la programación de canales de cable y televisión abierta. Este plan incluye un decodificador Entel TV y puedes agregar más por $3.490/mes',
                                info: 'Disfruta los últimos estrenos del cine, las mejores series en tu idioma y el mejor deporte del mundo en vivo.',
                                incluye: [
                                    {
                                        id: 1,
                                        icon: <IconTv size='25' />,
                                        name: 'Podrás difrutar 98 canales totales, 84 en  HD'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Sin límite de pantallas en uso simultáneo'
                                    },
                                    {
                                        id: 3,
                                        icon: <Icon24Hrs size='40' />,
                                        name: 'Vulve a ver el contenido emitido en las últimas 24 hrs y pausa tu programación favorita'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconRouter size='25' />,
                                        name: 'Incluye 1 decodificador Entel TV(requiere instalación)'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconCanalPremium size='25' />,
                                        name: 'Podrás agregar canales Premium'
                                    }
                                ]
                            }
                        },
                        beneficioTres: {
                            icon: <IconExtensor size='33' />,
                            name: 'Extensor WiFi 6',
                            content: {
                                incluye: 'Incluye hasta 1 extensor según evaluación técnica',
                                description: '¿Que es un extensor WiFi 6?<br />Es un dispositivo que mejora tu experiencia de navegación. ¡Mayor cobertura, estabilidad y velocidad dentro de tu hogar!<br /><br />Con 1 extensor podrás tener 2 puntos de Internet en tu Hogar.<br />Puedes arrendar más extensores por solo $2.990/mes cada uno (máximo 4 extensores por cliente).',
                                titleBeneficios: 'Beneficios de uso de extensor WiFi 6:',
                                beneficios: [
                                    {
                                        id: 1,
                                        icon: <IconHogarNew size='53' color='#002EFF' />,
                                        name: 'WiFi de alta velocidad, mayor cobertura y estabilidad dentro de tu hogar, a pesar de la cantidad de dispositivos conectados'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconCorazon size='25' />,
                                        name: 'Estéticamente amigables con la decoración del hogar'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconComunidad size='40' />,
                                        name: 'Una sola red, los distintos dispositivos se conectan automáticamente a la red óptima'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconSeguridad size='25' />,
                                        name: 'Dual band, red 2.4 y 5 GHZ, en una sola red'
                                    }
                                ]
                            }
                        },
                        incluye: [
                            {
                                id: 1,
                                name: 'App <b>Max</b> y <b>Pack HBO</b> de 8 canales.'
                            },
                            {
                                id: 2,
                                name: 'Suscripción a <b>Disney+ Premium.</b>'
                            },
                            {
                                id: 3,
                                name: 'Suscripción a <b>YouTube Premium Lite.</b>'
                            },
                            {
                                id: 7,
                                name: 'Suscripción a <b>Apple TV.</b>'
                            },
                            {
                                id: 8,
                                name: 'Suscripción a <b>Fanatiz.</b>'
                            },
                            {
                                id: 4,
                                name: 'Uso de tu <b>Deco Entel TV</b> sólo dentro de tu hogar'
                            },
                            {
                                id: 5,
                                name: 'Uso de <b>App Entel TV</b> en disp. móviles <b>donde quieras</b>'
                            },
                            {
                                id: 6,
                                name: 'Uso de <b>App Entel TV</b> para Smart TV sólo dentro de tu hogar'
                            }
                        ],
                        adicionalesUno: '',
                        adicionalesDos: {
                            id: 1,
                            icon: <IconTntSport />,
                            name: 'Suscribete a <b>TNT Sports Premium por $14.590/mes</b>',
                            content: {
                                description: '<b>¡Aprovecha el primer mes sin costo!</b> Esta suscripción incluye acceso a TNT Sports Premium en la app de Max y los canales TNT Sports Premium SD yx HD.',
                                logos: [
                                    {
                                        id: 1,
                                        logo: tntSport
                                    },
                                    {
                                        id: 2,
                                        logo: tntHbo
                                    }
                                ],
                                tyt: '*TNT Sports Premium sin costo por 1 mes. Solo nuevas contrataciones. (Precio nomal: $14.590)'
                            }
                        }
                    }
                },
                {
                    id: 4,
                    id2: 22,
                    megas: '800',
                    destacado: 0,
                    nuevo: 0,
                    especial: 6,
                    extra: '+ Extensor',
                    plan: 'Fibra 800 TV Lite+',
                    planType: 'lite',
                    incluyeUno: Disney,
                    incluyeDos: EntelTV,
                    incluyeTres: Canales46,
                    incluyeCuatro: '',
                    dcto: '32%',
                    precio: '$29.990',
                    luego: 'Precio normal: $43.990/mes',
                    precioLuego: '43990',
                    timeOffer: '12 meses',
                    items: [
                        {
                            id: 1,
                            icon: <IconTv size='16' color='#002EFF' />,
                            info: `<b>59 Canales</b> en total`
                        },
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>16 dispositivos</b>`
                        },
                        {
                            id: 5,
                            icon: <IconVelocidad size='16' color='#002EFF' />,
                            info: `Velocidad <b>máxima 800Mbps y mínima garantizada 50Mbps.</b> <u style="color: #002EFF">Conocer más</u>`
                        },
                        {
                            id: 4,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `<b>Hasta 1 extensor WiFi 6</b> según evaluación técnica`
                        },
                    ],
                    drawer: {
                        megas: '800',
                        plan: 'TV Lite+',
                        icon: '',
                        name: '',
                        description: '',
                        beneficioUno: {
                            icon: <IconVelocidad size='25px' />,
                            name: 'Velocidad de navegación',
                            content: {
                                icon: <IconSimetrica size='20' />,
                                name: 'Velocidad simétrica',
                                description: 'Cuando tu plan tiene los mismos megas de subida y bajada.',
                                megas: '800 Mbps',
                                ideal: [
                                    {
                                        id: 1,
                                        icon: <IconEquipo size='25' />,
                                        name: 'Conectar hasta 14 - 16 dispositivos simultáneamente'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconEjecutivo color='#002EFF' size='33' />,
                                        name: 'Realizar videoconferencia. Descargar y subir archivos rápidamente'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Trabajar y estudiar a distancia'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='25' />,
                                        name: 'Ver películas y series en HD'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconGamer size='25' />,
                                        name: 'Jugar en línea <b>como profesional</b>'
                                    }
                                ]
                            }
                        },
                        beneficioDos: {
                            icon: <IconTvEntel size='33' />,
                            name: 'Entel TV - TV Lite+',
                            content: {
                                canales: '59 Canales en total',
                                desglose: '47 en HD + 1 Deco Entel TV',
                                description: 'Vive una experiencia superior con Deco Entel TV Este plan incluye un decodificador Entel TV y puedes agregar más por $3.490/mes',
                                info: 'TV online, donde y cuando quieras TV Lite es como la televisión tradicional, pero online: ¡La señal llega por internet!',
                                incluye: [
                                    {
                                        id: 1,
                                        icon: <IconTv size='25' />,
                                        name: 'Podrás difrutar <strong style="color: #002EFF"><u>59 canales totales, 47 en HD</u></strong>'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconEquipoEntel size='25' />,
                                        name: 'Contenido disponible donde quieras con tu App Entel TV'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Hasta 2 pantallas en uso simultáneo'
                                    },
                                    {
                                        id: 4,
                                        icon: <Icon24Hrs size='40' />,
                                        name: 'Vulve a ver el contenido emitido en las últimas 24 hrs y pausa tu programación favorita'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconRouter size='25' />,
                                        name: 'incluye 1 decodificador (autoinstalable)'
                                    }
                                ]
                            }
                        },
                        beneficioTres: {
                            icon: <IconExtensor size='25' />,
                            name: 'Extensor',
                            content: {
                                incluye: 'Incluye hasta 1 extensor según evaluación técnica',
                                description: '¿Que es un extensor WiFi?<br />Es un dispositivo que mejora tu experiencia de navegación. ¡Mayor cobertura, estabilidad y velocidad dentro de tu hogar!<br /><br />Con 1 extensor podrás tener 2 puntos de Internet en tu Hogar.<br />Puedes arrendar más extensores por solo $2.990/mes cada uno (máximo 4 extensores por cliente).',
                                titleBeneficios: 'Beneficios de uso de extensor WiFi 6:',
                                beneficios: [
                                    {
                                        id: 1,
                                        icon: <IconHogarNew size='53' color='#002EFF' />,
                                        name: 'WiFi de alta velocidad, mayor cobertura y estabilidad dentro de tu hogar, a pesar de la cantidad de dispositivos conectados'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconCorazon size='25' />,
                                        name: 'Estéticamente amigables con la decoración del hogar'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconComunidad size='40' />,
                                        name: 'Una sola red, los distintos dispositivos se conectan automáticamente a la red óptima'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconSeguridad size='25' />,
                                        name: 'Dual band, red 2.4 y 5 GHZ, en una sola red'
                                    }
                                ]
                            }
                        },
                        incluye: [
                            {
                                id: 1,
                                name: 'Uso de App Entel TV en disp. móviles <b>donde quieras</b>'
                            },
                            {
                                id: 2,
                                name: 'Uso de Appe Entel TV en smart TV <b>donde quieras</b>'
                            },
                            {
                                id: 3,
                                name: 'Suscripción a <b>Disney + Premiun.</b>'
                            },
                        ],
                        adicionalesUno: '',
                        adicionalesDos: {
                            id: 1,
                            icon: <IconTntSport />,
                            name: 'Suscribete a <b>TNT Sports Premium por $14.590/mes</b>',
                            content: {
                                description: '<b>¡Aprovecha el primer mes sin costo!</b> Esta suscripción incluye acceso a TNT Sports Premium en la app de Max y los canales TNT Sports Premium SD yx HD.',
                                logos: [
                                    {
                                        id: 1,
                                        logo: tntSport
                                    },
                                    {
                                        id: 2,
                                        logo: tntHbo
                                    }
                                ],
                                tyt: '*TNT Sports Premium sin costo por 1 mes. Solo nuevas contrataciones. (Precio nomal: $14.590)'
                            }
                        }
                    }
                },
            ]
        },
        {
            id: 3,
            cantidad: '<b>Giga</b>',
            desde: '- Desde $33.990',
            planes: [
                {   
                    id: 5,
                    id2: 31,
                    megas: 'Giga',
                    plan: 'Fibra Giga TV Full+',
                    planType: 'full',
                    destacado: 0,
                    nuevo: 0,
                    especial: 7,
                    extra: '+ Extensor',
                    incluyeDos: Youtube,
                    incluyeUno: Disney,
                    incluyeCero: appletv,
                    incluyeCuatro: Fantiz,
                    incluyeQuinto: EntelTV,
                    incluyeTres: Max,
                    incluyeSeis: Canales,
                    dcto: '34%',
                    precio: '$39.990',
                    luego: 'Precio normal: $60.490/mes',
                    precioLuego: '60490',
                    timeOffer: '12 meses',
                    ciberDestacado:false,
                    items: [
                        {
                            id: 3,
                            icon: <IconTv size='16' color='#002EFF' />,
                            info: `1 Deco Audio Box y <br /><b>98 Canales</b> en total`
                        },
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>30 dispositivos</b>`
                        },
                        {
                            id: 4,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `<b>Hasta 1 extensor WiFi 7</b> según evaluación técnica`
                        },
                        {
                            id: 5,
                            icon: <IconVelocidad size='16' color='#002EFF' />,
                            info: `Velocidad <b>máxima 940Mbps y mínima garantizada 50 Mbps.</b> <u style="color: #002EFF">Conocer más</u>`
                        }
                    ],
                    drawer: {
                        megas: 'Giga',
                        plan: 'TV Full+',
                        icon: <IconRouter size='20' />,
                        name: '<b>¿Qué es WiFi 7?</b>',
                        description: 'Tecnología de última generación que <b>ofrece mayor velocidad y menor latencia dentro de tu hogar</b>, ideal para streaming, gaming y múltiples dispositivos conectados al mismo tiempo sin interrupciones.',
                        beneficioUno: {
                            icon: <IconVelocidad size='25px' />,
                            name: 'Velocidad de navegación',
                            content: {
                                icon: <IconSimetrica size='20' />,
                                name: 'Velocidad simétrica',
                                description: 'Cuando tu plan tiene los mismos megas de subida y bajada.',
                                megas: '940 Mbps',
                                ideal: [
                                    {
                                        id: 1,
                                        icon: <IconEquipo size='25' />,
                                        name: 'Conectar hasta 14 - 16 dispositivos simultáneamente'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconEjecutivo color='#002EFF' size='33' />,
                                        name: 'Realizar videoconferencia. Descargar y subir archivos rápidamente'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Trabajar y estudiar a distancia'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='25' />,
                                        name: 'Ver películas y series en HD'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconGamer size='25' />,
                                        name: 'Jugar en línea <b>como profesional</b>'
                                    }
                                ]
                            }
                        },
                        beneficioDos: {
                            icon: <IconTvEntel size='33' />,
                            name: 'Entel TV - TV Full+',
                            content: {
                                canales: '98 Canales en total',
                                desglose: '84 en  HD + 1 Deco Audio Box',
                                description: 'Televisión Fibra HD<br />Permite acceder a la programación de canales de cable y televisión abierta. Este plan incluye un decodificador Audiobox y puedes agregar más por $6.490/mes.',
                                info: 'Disfruta los últimos estrenos del cine, las mejores series en tu idioma y el mejor deporte del mundo en vivo.',
                                incluye: [
                                    {
                                        id: 1,
                                        icon: <IconTv size='25' />,
                                        name: 'Podrás difrutar <strong style="color: #002EFF"><u>98 canales totales, 84 en HD</u></strong>'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Sin límite de pantallas en uso simultáneo'
                                    },
                                    {
                                        id: 3,
                                        icon: <Icon24Hrs size='40' />,
                                        name: 'Vulve a ver el contenido emitido en las últimas 24 hrs y pausa tu programación favorita'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconRouter size='25' />,
                                        name: 'Incluye 1 decodificador Audiobox (requiere instalación)'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconCanalPremium size='25' />,
                                        name: 'Podrás agregar canales Premium'
                                    }
                                ]
                            }
                        },
                        beneficioTres: {
                            icon: <IconExtensor size='33' />,
                            name: 'Extensor WiFi 7',
                            content: {
                                incluye: 'Incluye hasta 1 extensor WiFi 7 según evaluación técnica',
                                description: '¿Que es un extensor WiFi 7?<br />La nueva generación de WiFi que ofrece más velocidad, menor latencia y máxima estabilidad para todos los dispositivos, incluso en los usos más exigentes.<br /><b>Con 1 extensor podrás tener 2 puntos de Internet en tu Hogar.</b><br />Puedes arrendar más extensores por solo $2.990/mes cada uno (máximo 4 extensores por cliente).<br />Beneficios clave de WiFi 7',
                                titleBeneficios: 'Beneficios de uso de extensor WiFi 7:',
                                beneficios: [
                                    {
                                        id: 1,
                                        icon: <IconVelocidad size='30' color='#002EFF' />,
                                        name: 'Aprovecha al máximo los planes de alta velocidad, evitando que la red se convierta en un cuello de botella.'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconHogarSencillo size='33' />,
                                        name: 'Ideal para videojuegos online, videollamadas sin cortes y aplicaciones en tiempo real. Las acciones responden de forma inmediata.'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconComunidad size='40' />,
                                        name: 'La red se adapta de forma inteligente para mantener una conexión fluida, incluso con muchos dispositivos conectados al mismo tiempo.'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconHogarNew size='25' />,
                                        name: 'Todos los dispositivos funcionan mejor, al mismo tiempo, sin caídas de calidad.'
                                    }
                                ]
                            }
                        },
                        beneficioCuatro: {
                            icon: <IconDeco sizeH='33' sizeW='33' />,
                            name: 'Deco Audio Box',
                            content: {
                                incluye: '',
                                description: '¡Ver TV en casa no será lo mismo con el nuevo deco Audio Box! Lo mejor de la tecnología en tu plan TV Full+ Giga.',
                                beneficios: [
                                    {
                                        id: 1,
                                        icon: <IconAudio size='26' color='#002EFF' />,
                                        name: 'Mejor experiencia de sonido gracias <b>a sus 3 parlantes integrados</b>'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconCrispetas size='23' />,
                                        name: 'Calidad de sonido envolvente <b>Dolby Atmos</b>'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconMensajes size='25' />,
                                        name: 'Control por voz a través de <b>Google Assistant</b>'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='23' />,
                                        name: 'Calidad de imagen <b>4K HDR</b>'
                                    }
                                ]
                            }
                        },
                        incluye: [
                            {
                                id: 1,
                                name: 'App <b>Max</b> y <b>Pack HBO</b> de 8 canales.'
                            },
                            {
                                id: 2,
                                name: 'Suscripción a <b>Disney+ Premium.</b>'
                            },
                            {
                                id: 5,
                                name: 'Suscripción a <b>Youtube Premium Lite.</b>'
                            },
                            {
                                id: 8,
                                name: 'Suscripción a <b>Apple TV.</b>'
                            },
                            {
                                id: 8,
                                name: 'Suscripción a <b>Fanatiz.</b>'
                            },
                            {
                                id: 3,
                                name: '<b>Hasta 1 extensor WiFi 7</b> según evaluación técnica'
                            },
                            {
                                id: 4,
                                name: 'Uso de tu <b>Deco Entel TV</b> sólo dentro de tu hogar'
                            },
                            {
                                id: 6,
                                name: 'Uso de <b>App Entel TV</b> en disp. móviles <b>donde quieras</b>'
                            },
                            {
                                id: 7,
                                name: 'Uso de <b>App Entel TV</b> para Smart TV sólo dentro de tu hogar'
                            },
                            {
                                id: 8,
                                name: '<b>1 Deco Audio Box.</b> Audio envolvente, control por voz, resolución 4K y mucho más.'
                            }
                        ],
                        adicionalesUno: '',
                        adicionalesDos: {
                            id: 1,
                            icon: <IconTntSport size='33' />,
                            name: 'Suscribete a <b>TNT Sports Premium por $14.590/mes</b>',
                            content: {
                                description: '<b>¡Aprovecha el primer mes sin costo!</b> Esta suscripción incluye acceso a TNT Sports Premium en la app de Max y los canales TNT Sports Premium SD yx HD.',
                                logos: [
                                    {
                                        id: 1,
                                        logo: tntSport
                                    },
                                    {
                                        id: 2,
                                        logo: tntHbo
                                    }
                                ],
                                tyt: '*TNT Sports Premium sin costo por 1 mes. Solo nuevas contrataciones. (Precio nomal: $14.590)'
                            }
                        }
                    }
                },
                {
                    id: 6,
                    id2: 32,
                    megas: '940',
                    plan: 'Fibra Giga TV Lite+',
                    planType: 'lite',
                    destacado: 0,
                    nuevo: 0,
                    especial: 7,
                    extra: '+ Extensor',
                    incluyeUno: Disney,
                    incluyeDos: EntelTV,
                    incluyeTres: Canales46,
                    incluyeCuatro: '',
                    dcto: '35%',
                    precio: '$33.990',
                    luego: 'Precio normal: $51.990/mes',
                    precioLuego: '51990',
                    timeOffer: '12 meses',
                    items: [
                        {
                            id: 1,
                            icon: <IconTv size='16' color='#002EFF' />,
                            info: `<b>59 Canales</b> en total`
                        },
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>30 dispositivos</b>`
                        },
                        {
                            id: 4,
                            icon: <IconExtensor color='#002EFF' />,
                            info: `<b>Hasta 1 extensor WiFi 7</b> según evaluación técnica`
                        },
                        {
                            id: 5,
                            icon: <IconVelocidad size='16' color='#002EFF' />,
                            info: `Velocidad <b>máxima 940Mbps y mínima garantizada 50Mbps.</b> <u style="color: #002EFF">Conocer más</u>`
                        },
                    ],
                    drawer: {
                        megas: 'Giga',
                        plan: 'TV Lite+',
                        icon: <IconRouter size='20' />,
                        name: '¿Qué es el nuevo <b>WiFi 6?</b>',
                        description: '¡Es la sexta generación WiFi! Una conexión más rápida, más estable y que te permite conectar más dispositivos en simultáneo. <strong style="color: #002EFF"><u>Conoce más sobre WiFi 6</u></strong>',
                        beneficioUno: {
                            icon: <IconVelocidad size='25px' />,
                            name: 'Velocidad de navegación',
                            content: {
                                icon: <IconSimetrica size='20' />,
                                name: 'Velocidad simétrica',
                                description: 'Cuando tu plan tiene los mismos megas de subida y bajada.',
                                megas: '940 Mbps',
                                ideal: [
                                    {
                                        id: 1,
                                        icon: <IconEquipo size='25' />,
                                        name: 'Conectar hasta 28 - 30 dispositivos simultáneamente'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconEjecutivo color='#002EFF' size='33' />,
                                        name: 'Realizar videoconferencia. Descargar y subir archivos rápidamente'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Trabajar y estudiar a distancia'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='25' />,
                                        name: 'Ver películas y series en full HD'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconGamer size='25' />,
                                        name: 'Jugar en línea como profesional <b>y en realidad virtual</b>'
                                    }
                                ]
                            }
                        },
                        beneficioDos: {
                            icon: <IconTvEntel size='33' />,
                            name: 'Entel TV - TV Lite+',
                            content: {
                                canales: '59 Canales en total',
                                desglose: '47 en HD + 1 Deco Entel TV',
                                description: 'Vive una experiencia superior con Deco Entel TV Este plan incluye un decodificador Entel TV y puedes agregar más por $3.490/mes',
                                info: 'TV online, donde y cuando quieras TV Lite es como la televisión tradicional, pero online: ¡La señal llega por internet!',
                                incluye: [
                                    {
                                        id: 1,
                                        icon: <IconTv size='25' />,
                                        name: 'Podrás difrutar <strong style="color: #002EFF"><u>59 canales totales, 47 en HD</u></strong>'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconEquipoEntel size='25' />,
                                        name: 'Contenido disponible donde quieras con tu App Entel TV'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Hasta 2 pantallas en uso simultáneo'
                                    },
                                    {
                                        id: 4,
                                        icon: <Icon24Hrs size='40' />,
                                        name: 'Vulve a ver el contenido emitido en las últimas 24 hrs y pausa tu programación favorita'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconRouter size='25' />,
                                        name: 'incluye 1 decodificador (autoinstalable)'
                                    }
                                ]
                            }
                        },
                        beneficioTres: {
                            icon: <IconExtensor size='33' />,
                            name: 'Extensor',
                            content: {
                                incluye: 'Incluye hasta 1 extensor WiFi 6 según evaluación técnica',
                                description: '¿Que es un extensor WiFi?<br />Es un dispositivo que mejora tu experiencia de navegación. ¡Mayor cobertura, estabilidad y velocidad dentro de tu hogar!<br /><br />Con 2 extensor podrás tener 3 puntos de Internet en tu Hogar.<br />Puedes arrendar más extensores por solo $2.990/mes cada uno (máximo 4 extensores por cliente).',
                                titleBeneficios: 'Beneficios de uso de extensor WiFi 6:',
                                beneficios: [
                                    {
                                        id: 1,
                                        icon: <IconHogarNew size='53' color='#002EFF' />,
                                        name: 'WiFi de alta velocidad, mayor cobertura y estabilidad dentro de tu hogar, a pesar de la cantidad de dispositivos conectados'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconCorazon size='25' />,
                                        name: 'Estéticamente amigables con la decoración del hogar'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconComunidad size='40' />,
                                        name: 'Una sola red, los distintos dispositivos se conectan automáticamente a la red óptima'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconSeguridad size='25' />,
                                        name: 'Dual band, red 2.4 y 5 GHZ, en una sola red'
                                    }
                                ]
                            }
                        },
                        incluye: [
                            {
                                id: 1,
                                name: 'Uso de App Entel TV en disp. móviles <b>donde quieras</b>'
                            },
                            {
                                id: 2,
                                name: 'Uso de Appe Entel TV en smart TV <b>donde quieras</b>'
                            },
                            {
                                id: 3,
                                name: 'Suscripción a <b>Disney + Premiun.</b>'
                            },
                        ],
                        adicionalesUno: '',
                        adicionalesDos: {
                            id: 1,
                            icon: <IconTntSport size='33' />,
                            name: 'Suscribete a <b>TNT Sports Premium por $14.590/mes</b>',
                            content: {
                                description: '<b>¡Aprovecha el primer mes sin costo!</b> Esta suscripción incluye acceso a TNT Sports Premium en la app de Max y los canales TNT Sports Premium SD yx HD.',
                                logos: [
                                    {
                                        id: 1,
                                        logo: tntSport
                                    },
                                    {
                                        id: 2,
                                        logo: tntHbo
                                    }
                                ],
                                tyt: '*TNT Sports Premium sin costo por 1 mes. Solo nuevas contrataciones. (Precio nomal: $14.590)'
                            }
                        }
                    }
                },
            ]
        },
        {
            id: 4,
            cantidad: '<b>2 Gigas</b>',
            desde: '- Desde $55.990',
            planes: [
                {
                    id: 7,
                    id2: 41,
                    megas: '2 Gigas',
                    plan: 'Fibra 2 Gigas TV Full+',
                    planType: 'full',
                    destacado: 0,
                    nuevo: 0,
                    especial: 7,
                    extra: '+ Extensor',
                    incluyeDos: Youtube,
                    incluyeUno: Disney,
                    incluyeCero: appletv,
                    incluyeCuatro: Fantiz,
                    incluyeQuinto: EntelTV,
                    incluyeTres: Max,
                    incluyeSeis: Canales,
                    dcto: '16%',
                    precio: '$55.990',
                    luego: 'Precio normal: $66.490/mes',
                    precioLuego: '60490',
                    timeOffer: '12 meses',
                    items: [
                        {
                            id: 1,
                            icon: <IconTv size='16' color='#002EFF' />,
                            info: `1 Deco Audio Box y <br /><b>98 Canales</b> en total`
                        },
                        {
                            id: 2,
                            icon: <IconTvMobile />,
                            info: `Conecta hasta <b>50 dispositivos</b>`
                        },
                        {
                            id: 3,
                            icon: <IconExtensor />,
                            info: `<b>Hasta 1 extensor WiFi 7</b> según evaluación técnica`
                        },
                        {
                            id: 5,
                            icon: <IconVelocidad size='16' color='#002EFF' />,
                            info: `Velocidad <b>máxima 940Mbps y mínima garantizada 50Mbps</b> <u style="color: #002EFF">Conocer más</u>`
                        }
                    ],
                    drawer: {
                        megas: '2 Giga',
                        plan: 'TV Full+',
                        icon: <IconRouter size='20' />,
                        name: '<b>¿Qué es WiFi 7?</b>',
                        description: 'Tecnología de última generación que <b>ofrece mayor velocidad y menor latencia dentro de tu hogar</b>, ideal para streaming, gaming y múltiples dispositivos conectados al mismo tiempo sin interrupciones.',
                        beneficioUno: {
                            icon: <IconVelocidad size='25px' />,
                            name: 'Velocidad de navegación',
                            content: {
                                icon: <IconSimetrica size='20' />,
                                name: 'Velocidad simétrica',
                                description: 'Cuando tu plan tiene los mismos megas de subida y bajada.',
                                megas: '2.000 Mbps',
                                ideal: [
                                    {
                                        id: 1,
                                        icon: <IconEquipo size='25' />,
                                        name: 'Conectar hasta 40 - 50 dispositivos simultáneamente'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconEjecutivo color='#002EFF' size='33' />,
                                        name: 'Realizar videoconferencia. Descargar y subir archivos rápidamente'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Trabajar y estudiar a distancia'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='25' />,
                                        name: 'Ver películas y series en HD'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconGamer size='25' />,
                                        name: 'Jugar en línea <b>como profesional</b>'
                                    }
                                ]
                            }
                        },
                        beneficioDos: {
                            icon: <IconTvEntel size='33' />,
                            name: 'Entel TV - TV Full+',
                            content: {
                                canales: '98 Canales en total',
                                desglose: '84 en  HD + 1 Deco Audio Box',
                                description: 'Televisión Fibra HD<br />Permite acceder a la programación de canales de cable y televisión abierta. Este plan incluye un decodificador Audiobox y puedes agregar más por $6.490/mes.',
                                info: 'Disfruta los últimos estrenos del cine, las mejores series en tu idioma y el mejor deporte del mundo en vivo.',
                                incluye: [
                                    {
                                        id: 1,
                                        icon: <IconTv size='25' />,
                                        name: 'Podrás difrutar <strong style="color: #002EFF"><u>98 canales totales, 84 en HD</u></strong>'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconUsuarios size='25' />,
                                        name: 'Sin límite de pantallas en uso simultáneo'
                                    },
                                    {
                                        id: 3,
                                        icon: <Icon24Hrs size='40' />,
                                        name: 'Vulve a ver el contenido emitido en las últimas 24 hrs y pausa tu programación favorita'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconRouter size='25' />,
                                        name: 'Incluye 1 decodificador Audiobox (requiere instalación)'
                                    },
                                    {
                                        id: 5,
                                        icon: <IconCanalPremium size='25' />,
                                        name: 'Podrás agregar canales Premium'
                                    }
                                ]
                            }
                        },
                        beneficioTres: {
                            icon: <IconExtensor size='33' />,
                            name: 'Extensor WiFi 7',
                            content: {
                                incluye: 'Incluye hasta 1 extensor WiFi 7 según evaluación técnica',
                                description: '¿Que es un extensor WiFi 7?<br />La nueva generación de WiFi que ofrece más velocidad, menor latencia y máxima estabilidad para todos los dispositivos, incluso en los usos más exigentes.<br /><b>Con 1 extensor podrás tener 2 puntos de Internet en tu Hogar.</b><br />Puedes arrendar más extensores por solo $2.990/mes cada uno (máximo 4 extensores por cliente).<br />Beneficios clave de WiFi 7',
                                titleBeneficios: 'Beneficios de uso de extensor WiFi 7:',
                                beneficios: [
                                    {
                                        id: 1,
                                        icon: <IconVelocidad size='30' color='#002EFF' />,
                                        name: 'Aprovecha al máximo los planes de alta velocidad, evitando que la red se convierta en un cuello de botella.'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconHogarSencillo size='33' />,
                                        name: 'Ideal para videojuegos online, videollamadas sin cortes y aplicaciones en tiempo real. Las acciones responden de forma inmediata.'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconComunidad size='40' />,
                                        name: 'La red se adapta de forma inteligente para mantener una conexión fluida, incluso con muchos dispositivos conectados al mismo tiempo.'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconHogarNew size='25' />,
                                        name: 'Todos los dispositivos funcionan mejor, al mismo tiempo, sin caídas de calidad.'
                                    }
                                ]
                            }
                        },
                        beneficioCuatro: {
                            icon: <IconDeco sizeH='33' sizeW='33' />,
                            name: 'Deco Audio Box',
                            content: {
                                incluye: '',
                                description: '¡Ver TV en casa no será lo mismo con el nuevo deco Audio Box! Lo mejor de la tecnología en tu plan TV Full+ Giga.',
                                beneficios: [
                                    {
                                        id: 1,
                                        icon: <IconAudio size='26' color='#002EFF' />,
                                        name: 'Mejor experiencia de sonido gracias <b>a sus 3 parlantes integrados</b>'
                                    },
                                    {
                                        id: 2,
                                        icon: <IconCrispetas size='23' />,
                                        name: 'Calidad de sonido envolvente <b>Dolby Atmos</b>'
                                    },
                                    {
                                        id: 3,
                                        icon: <IconMensajes size='25' />,
                                        name: 'Control por voz a través de <b>Google Assistant</b>'
                                    },
                                    {
                                        id: 4,
                                        icon: <IconTv size='23' />,
                                        name: 'Calidad de imagen <b>4K HDR</b>'
                                    }
                                ]
                            }
                        },
                        incluye: [
                            {
                                id: 1,
                                name: 'App <b>Max</b> y <b>Pack HBO</b> de 8 canales.'
                            },
                            {
                                id: 2,
                                name: 'Suscripción a <b>Disney+ Premium.</b>'
                            },
                            {
                                id: 5,
                                name: 'Suscripción a <b>Youtube Premium Lite.</b>'
                            },
                            {
                                id: 10,
                                name: 'Suscripción a <b>Apple TV.</b>'
                            },
                            {
                                id: 11,
                                name: 'Suscripción a <b>Fanatiz.</b>'
                            },
                            {
                                id: 3,
                                name: '<b>Hasta 1 extensor WiFi 7</b> según evaluación técnica'
                            },
                            {
                                id: 4,
                                name: 'Uso de tu <b>Deco Entel TV</b> sólo dentro de tu hogar'
                            },
                            {
                                id: 6,
                                name: 'Uso de <b>App Entel TV</b> en disp. móviles <b>donde quieras</b>'
                            },
                            {
                                id: 7,
                                name: 'Uso de <b>App Entel TV</b> para Smart TV sólo dentro de tu hogar'
                            },
                            {
                                id: 8,
                                name: '<b>1 Deco Audio Box.</b> Audio envolvente, control por voz, resolución 4K y mucho más.'
                            },
                            {
                                id: 9,
                                name: 'La <b>App Entel TV</b> es compatible con Smart TV <b>Samsung y LG año 2017</b> en adelante. Para otros modelos, considera un decodificador adicional.'
                            }
                        ],
                        adicionalesUno: '',
                        adicionalesDos: {
                            id: 1,
                            icon: <IconTntSport size='33' />,
                            name: 'Suscribete a <b>TNT Sports Premium por $14.590/mes</b>',
                            content: {
                                description: '<b>¡Aprovecha el primer mes sin costo!</b> Esta suscripción incluye acceso a TNT Sports Premium en la app de Max y los canales TNT Sports Premium SD yx HD.',
                                logos: [
                                    {
                                        id: 1,
                                        logo: tntSport
                                    },
                                    {
                                        id: 2,
                                        logo: tntHbo
                                    }
                                ],
                                tyt: '*TNT Sports Premium sin costo por 1 mes. Solo nuevas contrataciones. (Precio nomal: $14.590)'
                            }
                        }
                    }
                },
            ]
        },
    ];

    useEffect(() => {
        if (tipo !== 'duo' && tipo !== 'internet') {
            setSeccionView('internet');
            navigate(`/internet-hogar/internet`, { replace: true });
        }
        const intervalId = setInterval(() => {
            const now = new Date().getTime();
            const target = new Date("2025-06-28T22:44:59").getTime();
            const difference = target - now;

            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            setTimeRemaining({ days, hours, minutes, seconds });

            if (difference < 0) {
                clearInterval(intervalId);
                setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const openToggleDetails = (plan, card) => {
        card ? setIndexDrawer(0) : setIndexDrawer();
        if (seccionView === 'internet') {
            window.dataLayer.push({
                'event': 'GARDevent',
                'eventCategory': 'entel ofertas - hogar - card plan',
                'eventAction': 'interaction',
                'eventLabel': 'mostrar detalle',
                'origen': 'entel',
                'segmento': 'hh',
                'mercado': 'pe',
                'eventPlan': plan?.plan.toLowerCase(),
                'price': plan?.precio.replace(/[$.]/g, ''),
                'plan_subprice': seccionView === 'internet' ? plan?.luego?.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', '') : plan?.precioLuego?.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                'type_offer': plan?.dcto.replace('%', 'porciento dcto'),
                'position': plan?.id,
            });

            setDataPlanDrawer({
                plan: plan?.plan,
                megas: plan?.megas,
                precio: plan?.precio,
                precioTyc: plan?.luego,
                luego: plan?.luego,
                disney: plan?.disney,
                dsct: plan?.dcto,
                dcto: plan?.dcto,
                id: `Fibra Form Plan ${plan?.id}`,
                onlyId: plan?.id
            });

            if (plan?.id === 1) {
                setDataDrawer();
            } else {
                if (plan?.id === 3 || plan?.id === 4) {
                    setDataDrawer({
                        id: plan?.id,
                        megas: plan?.plan,
                        icon: <IconRouter />,
                        infoIcon: '¿Qué es WiFi 7?',
                        texto: 'Tecnología de última generación que <b>ofrece mayor velocidad y menor latencia dentro de tu hogar</b>, ideal para streaming, gaming y múltiples dispositivos conectados al mismo tiempo sin interrupciones.',
                        link: 'Conoce más sobre WiFi 7',
                        megasUpAndDown: plan?.id === 3 ? '940 Mbps' : '2.000 Mbps',
                        infoPlus: [
                            {
                                id: 1,
                                icon: <IconEquipo color='#002EFF' size='20px' />,
                                text: 'Conectar hasta 28-30 dispositivos simultáneamente'
                            },
                            {
                                id: 2,
                                icon: <IconUnion color='#002EFF' sizeW='22px' />,
                                text: 'Realizar videoconferencias. Descargar y subir archivos en segundos'
                            },
                            {
                                id: 3,
                                icon: <IconUsuarios size='20px' />,
                                text: 'Tabajar y estudiar a distancia'
                            },
                            {
                                id: 4,
                                icon: <IconTv size='20px' />,
                                text: 'Ver peliculas y series en la máxima calidad y definición'
                            },
                            {
                                id: 5,
                                icon: <IconGamer size='20px' />,
                                text: 'Jugar en línea como profesional y en realidad virtual'
                            }
                        ],
                        extensor: 1,
                        infoExtensor: 'extensores WiFi 7',
                        puntosInternet: 2
                    })
                } else {
                    setDataDrawer({
                        id: plan?.id,
                        megas: plan?.plan,
                        icon: <IconRouter />,
                        infoIcon: '¿Qué es WiFi 6?',
                        texto: `Tecnología que te ofrece una <b>navegación más rápida, estable y eficiente</b> incluso cuando todos están usando internet.`,
                        link: 'Cononce más sobre WiFi 6',
                        megasUpAndDown: plan?.id === 2 ? '800 Mbps' : '940 Mbps',
                        infoPlus: [
                            {
                                id: 1,
                                icon: <IconEquipo color='#002EFF' size='20px' />,
                                text: plan?.id === 2 ? 'Conectar hasta 14-16 dispositivos simultáneamente' : 'Conectar hasta 28-30 dispositivos simultáneamente'
                            },
                            {
                                id: 2,
                                icon: <IconUnion color='#002EFF' sizeW='22px' />,
                                text: plan?.id === 2 ? 'Realizar videoconferencias. Descargar y subir archivos rápidamente' : 'Realizar videoconferencias. Descargar y subir archivos en segundos'
                            },
                            {
                                id: 3,
                                icon: <IconUsuarios size='20px' />,
                                text: 'Tabajar y estudiar a distancia'
                            },
                            {
                                id: 4,
                                icon: <IconTv size='20px' />,
                                text: plan?.id === 2 ? 'Ver peliculas y series en full HD' : 'Ver peliculas y series en la máxima calidad y definición'
                            },
                            {
                                id: 5,
                                icon: <IconGamer size='20px' />,
                                text: plan?.id === 2 ? 'Jugar en línea como profesional' : 'Jugar en línea como profesional y en realidad virtual'
                            }
                        ],
                        extensor: plan?.id === 1 ? 2 : 1,
                        infoExtensor: plan?.id === 3 ? 'extensores WiFi 7' : 'extensores WiFi 6',
                        puntosInternet: plan?.id === 1 ? 3 : 2
                    })
                }
            }

            dataLayer.push({
                event: 'GARDNIevent',
                eventCategory: "entel ofertas - modal lateral",
                eventAction: "info",
                eventLabel: "carga",
                origen: "entel",
                segmento: "hh",
                mercado: "pe",
                eventPlan: plan?.plan.toLowerCase(),
                price: plan?.precio.replace(/[$.]/g, ''),
                plan_subprice: plan?.luego.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                type_offer: plan?.dcto.replace('%', 'porciento dcto'),
                position: plan?.id
            });
        } else {
            dataLayer.push({
                event: 'GARDevent',
                eventCategory: 'entel ofertas - card plan',
                eventAction: 'interaction',
                eventLabel: 'mostrar detalle completo',
                origen: 'entel',
                segmento: 'hh',
                mercado: 'pe',
                product_name: `duo fibra ${plan.megas}`,
                product_price: plan?.precio.replace(/[$.]/g, ''),
                product_subprice: plan?.luego.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                product_id: `duo-pack-${plan.plan.replace('+', '').replace(/ /g, '-').toLowerCase()}`,
                position: plan.id,
            });

            setDataPlanDrawer({
                plan: plan?.megas,
                precio: plan?.precio,
                precioTyc: plan?.luego,
                luego: plan?.luego,
                dsct: plan?.dcto,
                dcto: plan?.dcto,
                id: `Fibra Duo Plan ${plan?.id}`,
                id2: plan?.id2,
                onlyId: plan?.id,
                namePlan: plan?.plan,
            });

            setDataDrawer(plan?.drawer);

            dataLayer.push({
                event: 'GARDNIevent',
                eventCategory: "entel ofertas - modal lateral",
                eventAction: "info",
                eventLabel: "carga",
                origen: "entel",
                segmento: "hh",
                mercado: "pe",
                eventPlan: `duo fibra ${plan.megas}`,
                price: plan?.precio.replace(/[$.]/g, ''),
                plan_subprice: plan?.luego.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                type_offer: plan?.dcto.replace('%', 'porciento dcto'),
                position: plan?.id
            });
        };

        onOpen();
    };

    const openNewPage = (id, megas, precio, subprecio, dcto, drawer, plan) => {
        seccionView === 'internet'
            ? window.dataLayer.push({
                'event': 'GARDevent',
                'eventCategory': `entel ofertas - ${drawer ? 'modal lateral' : 'card plan'}`,
                'eventAction': 'click to action',
                'eventLabel': 'lo quiero',
                'origen': 'entel',
                'segmento': 'hh',
                'mercado': 'pe',
                'eventPlan': megas.toLowerCase(),
                'price': precio.replace(/[$.]/g, ''),
                'plan_subprice': subprecio.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                'type_offer': dcto.replace('%', 'porciento dcto'),
                'position': id,
            })
            : window.dataLayer.push({
                'event': 'GARDevent',
                'eventCategory': `entel ofertas - ${drawer ? 'modal lateral' : 'card plan'}`,
                'eventAction': 'click to action',
                'eventLabel': 'lo quiero',
                'origen': 'entel',
                'segmento': 'hh',
                'mercado': 'pe',
                "product_name": `duo fibra ${megas}`,
                "product_price": precio.replace(/[$.]/g, ''),
                "product_subprice": subprecio.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                "product_id": `duo-pack-fibra-${megas}-${plan.replace('+', '').replace(/ /g, '-').toLowerCase()}`,
                "position": id,
            })

        setPrecioNormalSolicitado(plan.luego.replace('Precio normal: ', '').replace('/mes', ''));
        // setRedirectPage('');
        setPrecioSolicitada(plan.precio);
        setPlanSolicitada(plan.plan);
        setDescuentoPlan(plan.dcto);
        setOpenSlideModal(true);

        openSlide(false, plan, precio, subprecio, dcto, id);
        navigate(`${enviroments.urlBase}/contratacion?planId=${id}&oda=entel-ofertas_card${id}&seccion=${seccionView}${seccionView === 'duo' ? `&plan=${megas}` : `&view=${planSelected}`}${gclid ? `&gclid=${gclid}` : ''}${campaignid ? `&campaignid=${campaignid}` : ''}${adgroupid ? `&adgroupid=${adgroupid}` : ''}${anuncioGroup ? `&group=${anuncioGroup}` : ''}${keyword ? `&keyword=${keyword}` : ''}${adId ? `&adId=${adId}` : ''}`)
    };

    const handleSeccionView = (seccion, onliRedirect) => {
        if (!onliRedirect) {
            window.dataLayer.push({
                event: 'GARDevent',
                eventCategory: 'entel ofertas - tab',
                eventAction: 'interaction',
                eventLabel: seccion,
                origen: 'entel',
                segmento: 'hh',
                mercado: 'pe',
            });
        };

        navigate(`${enviroments?.urlBase}/internet-hogar/${seccion}`, { replace: true });
        setSeccionView(seccion);
    };

    const openSlide = (seccionBanner, plan) => {
        // window.dataLayer.push({
        //     'event': 'GARDevent',
        //     'eventCategory': `entel ofertas - ¿como quieres contratar?`,
        //     'eventAction':'click to action',
        //     'eventLabel': 'Contratar con un ejecutivo',
        //     'origen':'entel',
        //     'segmento': 'hh',
        //     'mercado':'pe',
        //     'page_owner':'publico',
        //     'page_type':'registro',
        //     'form_name':'¿como quieres contratar tu plan?',
        //     'form_step_name':'paso 0-¿como quires contratar tu plan?-nuevo cliente',
        //     'form_type':'flujo digital',
        //     'journey_type':'solicitud',
        //     'journey_name': 'hogar',
        //     'eventPlan': plan.toLowerCase(),
        //     'price': precio.replace(/[$.]/g, ''),
        //     'plan_subprice': luego.replace(/[$.]/g, ''),
        //     'type_offer': dcto.replace('%', 'porciento dcto'),
        //     'visitor_type':'nuevo cliente',
        // })

        if (seccionBanner) {
            window.dataLayer.push({
                event: "GARDevent",
                eventCategory: "entel ofertas - banner principal",
                eventAction: "click to action",
                eventLabel: "lo quiero",
                origen: "entel",
                segmento: "hh",
                mercado: "pe",
                description: "precios desde 16990 por tiempo limitado",
                variant: "formulario banner principal hogar"
            });

            setPrecioNormalSolicitado("");
            setPrecioSolicitada("");
            setId(seccionView === 'duo' ? 'form_banner_hogar_duo' : `form_banner_hogar`);
            setPlanSolicitada("Formulario Banner");
            setDescuentoPlan("");
        } else {
            setNamePlan(plan?.plan);
            window.dataLayer.push({
                'event': 'GARDevent',
                'eventCategory': `entel ofertas - ¿como quieres contratar?`,
                'eventAction': 'click to action',
                'eventLabel': 'Contratar con un ejecutivo',
                'origen': 'entel',
                'segmento': 'hh',
                'mercado': 'pe',
                'page_owner': 'publico',
                'page_type': 'registro',
                'form_name': '¿como quieres contratar tu plan?',
                'form_step_name': 'paso 0-¿como quires contratar tu plan?-nuevo cliente',
                'form_type': 'c2c',
                'journey_type': 'solicitud',
                'journey_name': 'hogar',
                'eventPlan': `${plan?.megas}`,
                'price': plan?.precio.replace(/[$.]/g, ''),
                'plan_subprice': plan?.luego.replace(/[$.]/g, '').replace('Precio normal: ', '').replace('/mes', ''),
                'type_offer': plan?.dcto.replace('%', 'porciento dcto'),
                'visitor_type': 'nuevo cliente',
            })

            // openNewPage(, dataPlanDrawer.plan, dataPlanDrawer.precio, dataPlanDrawer.precioTyc, dataPlanDrawer.dsct, true, dataPlanDrawer.namePlan)

            if (seccionView === 'duo') {
                setTypePlan(plan?.plan?.replace('Fibra ', '').replace('+', ''));
                setId(`Fibra Duo Form Plan ${plan?.id2}`);
                setPlanSolicitada(`${plan.megas} Megas`);
            } else if (plan?.disney) {
                setPlanSolicitada(plan.megas);
                setId(`Fibra_Form_Con_Disney_Plan_${plan?.id}`);
            } else if (!plan?.disney) {
                setPlanSolicitada(plan.megas);
                setId(`Fibra Form Plan ${plan?.id}`);
            }

            setPrecioNormalSolicitado(plan.luego.replace('Precio normal: ', '').replace('/mes', ''));
            // setRedirectPage('');
            setPrecioSolicitada(plan.precio);
            setDescuentoPlan(plan.dcto);
        }

        // setId(`Fibra Form Plan ${id}`);
        setIsBanner(seccionBanner);
        setOpenSlideModal(true);
    };

    const handleChangePlan = (id, plan) => {
        if (seccionView === 'internet') {
            setPlanSelected(id);
            window.dataLayer.push({
                event: 'GARDevent',
                eventCategory: 'entel ofertas - radio',
                eventAction: 'interaction',
                eventLabel: planSelected === 2 ? 'sin disney' : 'con disney',
                origen: 'entel',
                segmento: 'hh',
                mercado: 'pe',
            });
        } else {
            // setPlanSelected(id);
            window.dataLayer.push({
                event: 'GARDevent',
                eventCategory: 'entel ofertas - radio',
                eventAction: 'interaction',
                eventLabel: plan?.replace(/<\/?b>/g, '').toLowerCase(),
                origen: 'entel',
                segmento: 'hh',
                mercado: 'pe',
            });

            localStorage.setItem('planSelectedDuo', id)
            setPlanSelectedDuo(id);
        }
    };

    return (
        <Box pos='relative'>
            {/* Banner */}
            {
                seccionView === 'internet' ? (
                    <Box position="relative" w="100%" h={['252px', '252px', '280px', '280px', '280px']} onClick={() => openSlide(true)}>
                        {/* Imagen principal */}
                        {/* <Image
                            src={planSelected == 1 ? BannerDk : BannerDkDisney}
                            srcSet={planSelected == 1
                                ? `${BannerMb} 768w, ${BannerDk} 1024w`
                                : `${BannerMbDisney} 768w, ${BannerDkDisney} 1024w`
                            }
                            sizes="(max-width: 768px) 100px, 1024px"
                            alt="Banner planes internet"
                            objectFit="cover"
                            objectPosition={planSelected == 1 ? 'center' : 'center'}
                            w="100%"
                            h="100%"
                        /> */}

                        <picture>
                            <source
                                media="(max-width: 768px)"
                                srcSet={planSelected == 1 ? BannerMb : BannerMbDisney}
                            />

                            <Image
                                src={planSelected == 1 ? BannerDk : BannerDkDisney}
                                alt="Banner planes internet"
                                objectFit="cover"
                                objectPosition="center"
                                w="100%"
                                h="100%"
                            />
                        </picture>

                        <Flex
                            position="absolute"
                            top="0"
                            left="0"
                            right="0"
                            w={{base: "80%", md: "90%"}}
                            h="100%"
                            flexDirection="row"
                            px="0"
                            mx={{base: '6', md: "auto"}}
                        >
                            <Box my="auto">
                                <HStack color={planSelected === 1 ? 'white' : 'white'}>
                                    <IconHogar color={planSelected === 1 ? 'white' : 'white'} />
                                    <Text className="General" fontSize="md">
                                        Planes internet Hogar
                                    </Text>
                                </HStack>

                                {
                                    planSelected == 1 ? (
                                        <Box color="white">
                                            <Heading fontWeight="400" fontSize={['26px','26px','42px']} className="General" lineHeight="1">
                                                <b>Más conexión</b> para tu hogar
                                            </Heading>
                                            <Heading fontWeight="400" fontSize={['26px','26px','42px']} className="General" lineHeight="1">
                                                <b>con Fibra Entel</b>
                                            </Heading>
{/* 
                                            <Flex my='3'>
                                                <Text whiteSpace="nowrap" bg='#FFCFBF' color='black' border='1px solid #FF3D00' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                    Últimas horas
                                                </Text>
                                            </Flex> */}
                                            
                                            {/* <Flex my='3'>
                                                <Text className='General' borderRadius='4px' py='0' h='auto' px='3' fontSize='sm' bg='white' color='black'>
                                                    Instalación <b>Gratis</b> - <b>Dctos. x 1 año</b>
                                                </Text>
                                            </Flex> */}
                                             
                                            <Text fontSize="10px">*Aplica solo para nuevas contrataciones</Text>
                                        </Box>
                                    ) : (
                                        <Box color="white">
                                            <Heading fontWeight="400" className="General" fontSize={['26px', '26px', '38px']} lineHeight="1">
                                                Estrenos en casa,
                                            </Heading>
                                            <Heading fontWeight="400" className="General" fontSize={['26px', '26px', '38px']} lineHeight="1">
                                                ya disponible <b>Moana</b>
                                            </Heading>
                                            <Heading fontWeight="400" mb='2' className="General" fontSize={['26px', '26px', '38px']} lineHeight="1">
                                                <b>en Disney+ Premium</b>
                                            </Heading>
                                            <Text fontSize="10px">*Aplica únicamente nuevas contrataciones</Text>
                                        </Box>
                                    )}

                                <Button
                                    onClick={() => openSlide(true)}
                                    size={['sm', 'sm', 'md']}
                                    borderRadius="30"
                                    w="40%"
                                    mt="2"
                                    className="General"
                                    border="2px solid white"
                                    bg="white"
                                    color="#002FFD"
                                    _hover={{ color: 'white', bg: '#002FFD', borderColor: '#002FFD' }}
                                >
                                    Lo quiero
                                </Button>
                            </Box>
                            <Spacer />
                        </Flex>
                    </Box>
                ) : (
                    <Box position="relative" w="100%" h={['242px', '242px', '255px', '255px', '255px']}>
                        {/* Imagen principal */}
                        <Image
                            src={BannerDkDuo}
                            srcSet={`${BannerMbDuo} 768w, ${BannerDkDuo} 1024w`}
                            sizes="(max-width: 768px) 100px, 1024px"
                            alt="Banner duo Disney"
                            objectFit="cover"
                            w="100%"
                            h="100%"
                        />

                        {/* Contenido encima */}
                        <Flex
                            position="absolute"
                            top="0"
                            left="0"
                            right="0"
                            w={{base: '80%', md: "90%"}}
                            h="100%"
                            flexDirection="row"
                            px="0"
                            mx={{base: '6', md: "auto"}}
                        >
                            <Box my="auto" color="#FFFF">
                                <HStack  mt={[4, 4, 0]}>
                                    <IconHogarDuo color='#FFFF' size="28" />
                                    <Text className="General" fontSize="md" >
                                        Dúo Pack: Internet + TV Hogar
                                    </Text>
                                </HStack>

                                
                                <Heading fontWeight="400" fontSize={['24px', '24px', '36px']} className="General" lineHeight="1" >
                                    Toda la entretención
                                </Heading>
                                <Heading fontWeight="400" fontSize={['24px', '24px', '36px']} className="General" lineHeight="1" >
                                    con el <b>Dúo pack</b>
                                </Heading>

                                <Heading mt="2" fontWeight="400" fontSize={'20px'} className="General" lineHeight="1" >
                                    Los planes con TV Full+ incluye:
                                </Heading>

                                {/* <Flex my='3'>
                                    <Text whiteSpace="nowrap" bg='#FFCFBF' color='black' border='1px solid #FF3D00' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                        Últimas horas
                                    </Text>
                                </Flex> */}
                                
                                <SimpleGrid columns={2} alignItems='center' mt='2'>
                                    <Button
                                        onClick={() => openSlide(true)}
                                        size={['sm', 'sm', 'md']}
                                        borderRadius="30"
                                        w="90%"
                                        display={{base: 'none', md: 'block'}}
                                        className="General"
                                        border="2px solid white"
                                        bg="white"
                                        color="#002FFD"
                                        _hover={{ color: 'white', bg: '#002FFD', borderColor: '#002FFD' }}
                                    >
                                        Lo quiero
                                    </Button>

                                    <HStack alignItems='center'>
                                        <Image src={appletv} w='35px' />
                                        <Image src={Disney} borderRadius='10px' w='35px' />
                                        <Image src={Youtube} w='35px' />
                                        <Image src={Max} w='35px' />
                                        <Image src={Fantiz} w='35px' />
                                        <Image src={Canales} w='35px' />
                                    </HStack>
                                </SimpleGrid>
                                <Text className='General' fontSize="10px" mt='0'>*Aplica Términos y Condiciones .</Text>
                            </Box>
                            <Spacer />
                        </Flex>
                    </Box>
                )
            }
            
            <Flex bg='#D0F9EC' borderTop='2px solid #42E8B4' px={{base: '7', md: '12'}} py='2' alignItems='center' gap='4'>
                <Box><IconTicket /></Box>
                <Text className='General'>Contrata un plan hogar y obtén <b>30% de descuento adicional en equipos y accesorios*.</b></Text>
            </Flex>

            {/* Planes */}
            <Box pt='4' position='relative'>
                {/* Fondo Planes */}
                {/* {
                    seccionView === 'duo'
                    ? <>
                        <Image src={fondoHogar} display={['none','none','none','block','block']} pos='absolute' top='-5' right='0' left='0' zIndex='-1' w='100%' h='100%' />
                        <Image src={fondoHogarMb} display={['block','block','block','none','none']} pos='absolute' top='-5' right='0' left='0' zIndex='-1' w='100%' h='100%' />
                    </>
                    : planSelected == 2 && <>
                        <Image src={fondoHogar} display={['none','none','none','block','block']} pos='absolute' top='-5' right='0' left='0' zIndex='-1' w='100%' h='100%' />
                        <Image src={fondoHogarMb} display={['block','block','block','none','none']} pos='absolute' top='0' right='0' left='0' zIndex='-1' w='100%' h='100%' />
                    </>
                } */}

                <Box mx="auto" w={['90%', '90%', '90%', '90%', '90%']}>
                    {/* Tipo plan */}
                    <SimpleGrid mb={['5', '5', '5', '12', '12']} columns='2' spacing='0' justifyContent='center' mx='auto' w={['100%', '100%', '38%', '38%', '38%']}>
                        <Box cursor='pointer' bg='white' borderBottom={`1px solid ${seccionView === 'internet' ? '#002EFF' : '#66686C'}`} textAlign='center' py='1' borderRadius='0' _hover={{ bg: '#F4F5FF' }} onClick={() => { handleSeccionView('internet', false); localStorage.setItem('viewSeccion', 'internet') }}>
                            {/* <Box mb="2" alignItems="center" justifyContent="center" display="flex" >
                                <Text w="40"  bg='#FFCFBF' border='1px solid #FF3D00' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                    Ofertas Cyber
                                </Text>
                            </Box> */}
                            <Flex justify='center'>
                                <IconHogar color={seccionView === 'internet' ? '#002EFF' : 'black'} size='32' />
                            </Flex>
                            <Text fontWeight={'500'} color={seccionView === 'internet' ? '#002EFF' : 'black'}>Internet</Text>
                        </Box>
                        <Box cursor='pointer' bg='white' borderBottom={`1px solid ${seccionView !== 'internet' ? '#002EFF' : '#66686C'}`} textAlign='center' py='1' borderRadius='0' _hover={{ bg: '#F4F5FF' }} onClick={() => { handleSeccionView('duo', false); localStorage.setItem('viewSeccion', 'duo') }}>
                            {/* <Box mb="2" alignItems="center" justifyContent="center" display="flex" >
                                <Text w="40"  bg='#FFCFBF' border='1px solid #FF3D00' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                    Ofertas Cyber
                                </Text>
                            </Box> */}
                            <Flex justifyContent='center'>
                                <IconHogarDuo color={seccionView !== 'internet' ? '#002EFF' : 'black'} />
                            </Flex>
                            <Text fontWeight={'500'} color={seccionView !== 'internet' ? '#002EFF' : 'black'}>Dúo Pack</Text>
                        </Box>
                    </SimpleGrid>

                    
                    
                    {
                        seccionView === 'internet'
                            ? <Box>
                                <Flex mb={['5', '5', '5', '12', '12']} gap='3' mx='auto' alignItems='center' justifyContent='center' w={['100%', '100%', '50%', '50%', '50%']}>
                                    <Text className='Title'>Selecciona un plan de internet</Text>
                                    <Switch defaultChecked={planSelected === 2} size='lg' sx={{ '_checked': { '> span:first-of-type': { bg: '#002eff', borderColor: '#002eff' }}}} onChange={() => handleChangePlan(planSelected == 1 ? 2 : 1)} />
                                    <Text className='General'>Disney+ Premium</Text>
                                </Flex>

                                <Box id="id-secction-slider-plan-position-internet-hogar" alignItems='center' justifyContent='center' mx='auto' display={['block', 'block', '-ms-flexbox', '-ms-flexbox', '-ms-flexbox']}>
                                    <Splide
                                        hasTrack={false}
                                        options={{
                                            perMove: 1,
                                            pagination: true,
                                            autoplay: false,
                                            gap: '20px',
                                            arrows: false,
                                            autoWidth: true,
                                        }}
                                    >
                                        <SplideTrack className='tarjets-planes-movil centerCards'>
                                            {
                                                planesHogar.filter((planes) => planes?.id === planSelected)[0]?.planes?.map((plan) => (
                                                    <SplideSlide key={plan.id}>
                                                        <Box pos='relative'>
                                                            <Box bg='white' width='330px' border={plan?.destacado ? '1px solid #D7D7D7' : '1px solid #CCCCCC'} borderRadius={'10px'} h='100%'>
                                                                {
                                                                    plan?.ciberDestacado ?
                                                                        <Box bgGradient="radial-gradient(circle, #0359C6 0%, #00236E 100%)" color="white" textAlign="center" borderTopLeftRadius="10px" borderTopRightRadius="10px" py="2" fontWeight="600">
                                                                            Cyber Entel
                                                                        </Box>
                                                                    : ''
                                                                }
                                                                {
                                                                    plan?.destacado
                                                                        ? <Box bg='#002EFF' borderTopRadius='10px'>
                                                                            <Heading size='md' color='white' textAlign='center' p='1' className='Subtitle'>
                                                                                <b>Recomendado</b>
                                                                            </Heading>
                                                                        </Box>
                                                                        : ''
                                                                }
                                                                <Box p="4">
                                                                    {
                                                                        plan?.especial
                                                                            ? <Flex gap='2' justifyContent='end' mb='3' right='5'>
                                                                                {
                                                                                    plan?.ciberDestacado ?
                                                                                        <Text whiteSpace="nowrap" bg='#FFCFBF' border='1px solid #FF3D00' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                                                            Últimas horas
                                                                                        </Text>
                                                                                    : ''
                                                                                }

                                                                                <Text whiteSpace="nowrap" bg='#fff' border='1px solid #31AE87' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                                                    Router {plan?.extra}
                                                                                </Text>

                                                                                <Text whiteSpace="nowrap" bg='#D0F9EC' border='1px solid #31AE87' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                                                    WiFi {plan?.especial}
                                                                                </Text>
                                                                            </Flex>
                                                                            : ''
                                                                    }

                                                                    {
                                                                        plan?.nuevo
                                                                            ? <Flex justifyContent='end' mb='3' gap='2' position='absolute' right='5'>
                                                                                <Text bg='#F3F5FF' border='1.5px solid #002EFF' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                                                    WiFi 7
                                                                                </Text>
                                                                            </Flex>
                                                                            : ''
                                                                    }

                                                                    <Text className="Subtitle">
                                                                        Internet
                                                                    </Text>

                                                                    {/* Megas */}
                                                                    <Heading className='Subtitle' size='md'>{plan.plan}</Heading>

                                                                    {/* Descuento Cyber */}
                                                                    <Flex className="SemiBold" mt='2'>
                                                                        <Text className='Title' color='black' borderLeftRadius={'5px'} py='2px' bg="#42E8B4" lineHeight='1' fontSize={{ base: 'xs', md: "sm" }} px='2'>{plan.dcto} dcto</Text>
                                                                        <Text className='Title' borderRightRadius={'5px'} py='2px' border="1px solid #42E8B4" lineHeight='1' fontSize={{ base: 'xs', md: "sm" }} px='1'>Oferta Online</Text>
                                                                    </Flex>

                                                                    {/* Precio */}
                                                                    <HStack mt="2" alignItems='flex-end' spacing="0">
                                                                        <Heading color="#002EFF" className="Subtitle" size="2xl">
                                                                            {plan.precio}
                                                                        </Heading>
                                                                        <Heading size='md' fontWeight='400' color="#002EFF" className="Subtitle">/{plan.timeOffer}</Heading>
                                                                    </HStack>

                                                                    {/* Tiempo oferta */}
                                                                    <Text fontSize="md" mt='1' textAlign="justify" color='#66686C' className="Subtitle" dangerouslySetInnerHTML={{ __html: plan.luego }}></Text>

                                                                    {/* Button */}
                                                                    <Button
                                                                        mt="4"
                                                                        bg='#002EFF'
                                                                        color="white"
                                                                        className="SemiBold"
                                                                        w="100%"
                                                                        borderRadius='30px'
                                                                        p="6"
                                                                        border='2px solid #002EFF'
                                                                        fontSize={'lg'}
                                                                        _hover={{ border: '2px solid #002EFF', bg: 'white', color: '#002EFF' }}
                                                                        onClick={() => openSlide(false, plan)}
                                                                    >
                                                                        Lo quiero
                                                                    </Button>

                                                                    {/* Router + extensión */}
                                                                    {
                                                                        planSelected === 2 &&
                                                                        <Box bg='#F3F5FF' borderRadius='12px' py='4' px='3' mt='4' mb={4}>
                                                                            <Text className='Title' mb='5'>Incluidos en tu plan:</Text>
                                                                            <HStack spacing={6}>
                                                                                <Image borderRadius='12px' src={Disney} w='22%' />
                                                                            </HStack>
                                                                        </Box>
                                                                    }

                                                                    {/* Beneficios oferta */}
                                                                    <Box mt="4">
                                                                        <VStack
                                                                            bg='#F3F5FF'
                                                                            borderRadius='12px'
                                                                            spacing={3}
                                                                            align='stretch'
                                                                            p="5"
                                                                        >
                                                                            {
                                                                                plan.items.map((beneficios) => (
                                                                                    <HStack spacing='10px' key={beneficios.id}>
                                                                                        <Box>
                                                                                            {beneficios.icon}
                                                                                        </Box>
                                                                                        <Flex>
                                                                                            {
                                                                                                beneficios.id === 4
                                                                                                    ? <Text fontSize="sm" className="Subtitle">
                                                                                                        Velocidad <b>máxima {plan.megas}Mbps y mínima garantizada 50 Mbps.</b> <a onClick={() => openToggleDetails(plan, true)} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#002EFF' }} className='Title'>Conocer más</a>
                                                                                                    </Text>
                                                                                                    : <Text fontSize="sm" className="Subtitle" dangerouslySetInnerHTML={{ __html: beneficios.info }}></Text>
                                                                                            }
                                                                                        </Flex>
                                                                                    </HStack>
                                                                                ))
                                                                            }
                                                                        </VStack>
                                                                    </Box>
                                                                </Box>

                                                                <Divider mt='1' borderColor='#CACACA' />

                                                                {/* Boton para ver más detalles */}
                                                                <Box p='4'>
                                                                    <Button
                                                                        onClick={() => openToggleDetails(plan, false)}
                                                                        textDecoration='underline'
                                                                        className="Subtitle"
                                                                        variant="link"
                                                                        fontSize='lg'
                                                                        rightIcon={<BsChevronRight size='25px' />}
                                                                        color="#002EFF"
                                                                        fontWeight="bold"
                                                                    >
                                                                        Detalle de plan
                                                                    </Button>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </SplideSlide>
                                                ))
                                            }
                                        </SplideTrack>
                                    </Splide>
                                </Box>
                            </Box> 
                            : <Box>
                                <Flex mb={['5', '5', '5', '12', '12']} gap="4" alignItems="center" justifyContent="center" w="100%">
                                    <Text>
                                        Elige un <b>plan de intrnet + TV</b>
                                    </Text>

                                    <Flex gap="4">

                                        {/* TV Full + */}
                                        <Flex w="40" py="3" bg="white" px="5" alignItems="center" borderRadius="10px" cursor="pointer" border={`1px solid ${planTypeSelect === 'full' ? '#002EFF' : '#66686C'}`} onClick={() => setPlanTypeSelect('full')}>
                                            <Box p="3px" mr="2" border={`1px solid ${planTypeSelect === 'full' ? '#002EFF' : '#66686C'}`} h="23px" borderRadius="50%" w="23px">
                                                <Box borderRadius="50%" bg={planTypeSelect === 'full' ? '#002EFF' : '#FFFF'} w="100%" h="100%"/>
                                            </Box>

                                            <Text className="General">
                                                TV Full +
                                            </Text>
                                        </Flex>

                                        {/* TV Lite + */}
                                        <Flex w="40" py="3" bg="white" px="5" alignItems="center" borderRadius="10px" cursor="pointer" border={`1px solid ${planTypeSelect === 'lite' ? '#002EFF' : '#66686C'}`} onClick={() => setPlanTypeSelect('lite')}>
                                            <Box p="3px" mr="2" border={`1px solid ${planTypeSelect === 'lite' ? '#002EFF' : '#66686C'}`} h="23px" borderRadius="50%" w="23px">
                                                <Box borderRadius="50%" bg={planTypeSelect === 'lite' ? '#002EFF' : '#FFFF'} w="100%" h="100%"/>
                                            </Box>

                                            <Text className="General">
                                                TV Lite +
                                            </Text>
                                        </Flex>

                                    </Flex>
                                </Flex>
                                {/* <Box display={['block', 'block', 'none', 'none', 'none']}> */}
                                <Box display="none">
                                    <Text className='Subtitle' color='white' fontSize='18px'>Selecciona la velocidad</Text>

                                    <Box mt='3' mb='10'>
                                        <Splide
                                            hasTrack={false}
                                            options={{
                                                perPage: 3,
                                                perMove: 1,
                                                autoplay: false,
                                                gap: '15px',
                                                arrows: false,
                                                pagination: true,
                                                breakpoints: {
                                                    650: {
                                                        perPage: 2,
                                                    }
                                                }
                                            }}
                                        >
                                            <SplideTrack>
                                                {
                                                    planesHogarDuo.map((planes) => (
                                                        <SplideSlide key={planes?.id}>
                                                            <Flex py='3' px='5' bg='white' alignItems='center' borderRadius='10px' cursor='pointer' color={planes?.id === planSelectedDuo ? '#002EFF' : 'black'} onClick={() => handleChangePlan(planes?.id, planes?.cantidad)} border={`1px solid ${planes?.id === planSelectedDuo ? '#002EFF' : '#D7D7D7'}`}>
                                                                <Box p='2.5px' mr='2' border={`1px solid ${planes?.id === planSelectedDuo ? '#002EFF' : '#66686C'}`} h='23px' borderRadius='50%' w='23px'>
                                                                    <Box borderRadius='50%' bg={planes?.id === planSelectedDuo && '#002EFF'} w='100%' h='100%'></Box>
                                                                </Box>
                                                                <Text className="General" dangerouslySetInnerHTML={{ __html: planes.cantidad }}></Text>
                                                            </Flex>
                                                        </SplideSlide>
                                                    ))
                                                }
                                            </SplideTrack>
                                        </Splide>
                                    </Box>
                                </Box>

                                <Flex display={['block', 'block', 'flex', 'flex', 'flex']}>
                                    {/* Selección de megas */}
                                    {/* <Box display={['none', 'none', 'none', 'block', 'block']} w='30%'> */}
                                    <Box display="none" w='30%'>
                                        {
                                            planesHogarDuo.map((planes) => (
                                                <Flex py='3' bg='white' px='5' alignItems='center' mb='5' key={planes?.id} borderRadius='10px' cursor='pointer' color={planes?.id === planSelectedDuo ? '#002EFF' : 'black'} onClick={() => handleChangePlan(planes?.id, planes?.cantidad)} border={`1px solid ${planes?.id === planSelectedDuo ? '#002EFF' : '#D7D7D7'}`}>
                                                    <Box p='3px' mr='2' border={`1px solid ${planes?.id === planSelectedDuo ? '#002EFF' : '#66686C'}`} h='23px' borderRadius='50%' w='23px'>
                                                        <Box borderRadius='50%' bg={planes?.id === planSelectedDuo && '#002EFF'} w='100%' h='100%'></Box>
                                                    </Box>
                                                    <Text className="General" dangerouslySetInnerHTML={{ __html: planes.cantidad }}></Text>
                                                    <Text className="General" ml='1' dangerouslySetInnerHTML={{ __html: planes.desde }}></Text>
                                                </Flex>
                                            ))
                                        }
                                    </Box>

                                    {/* <Box ml={[0, 0, 0, 7, 7]} w={['100%', '100%', '70%', '70%', '70%']} pb='10'> */}
                                    <Box ml={[0, 0, 0, 7, 7]} w="100" pb='10'>

                                        <Splide
                                            hasTrack={false}
                                            options={{
                                                perMove: 1,
                                                pagination: true,
                                                autoplay: false,
                                                gap: '25px',
                                                arrows: false,
                                                autoWidth: true,
                                            }}
                                        >
                                            <SplideTrack className='tarjets-planes-movil'>
                                                {
                                                    // planesHogarDuo.filter((planes) => planes?.id === planSelectedDuo)[0]?.planes?.map((plan) => (
                                                    planesHogarDuo.flatMap((planes) => planes?.planes?.filter((plan) => plan?.planType === planTypeSelect)).map((plan) => (
                                                        <SplideSlide key={plan.id}>
                                                            <Box pos='relative' width='330px'>
                                                                <Box bg='white' border={plan?.destacado ? '1px solid #CCCCCC' : '1px solid #CCCCCC'} borderRadius='10px'>
                                                                    {
                                                                        plan?.ciberDestacado ?
                                                                            <Box bgGradient="radial-gradient(circle, #0359C6 0%, #00236E 100%)" color="white" textAlign="center" borderTopLeftRadius="10px" borderTopRightRadius="10px" py="2" fontWeight="600">
                                                                                Cyber Entel
                                                                            </Box>
                                                                        : ''
                                                                    }
                                                                    {
                                                                        plan?.destacado
                                                                            ? <Box bg='#002EFF' borderTopRadius='10px'>
                                                                                <Heading size='md' color='white' textAlign='center' p='1' className='Subtitle'>
                                                                                    <b>Recomendado</b>
                                                                                </Heading>
                                                                            </Box>
                                                                            : ''
                                                                    }
                                                                    <Box p="4">
                                                                        {
                                                                            plan?.especial
                                                                                ? <Flex justifyContent='end' mb='3' gap='2' right='5'>
                                                                                    {
                                                                                        plan?.ciberDestacado ?
                                                                                            <Text whiteSpace="nowrap" bg='#FFCFBF' border='1px solid #FF3D00' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                                                                Últimas horas
                                                                                            </Text>
                                                                                        : ''
                                                                                    }
                                                                                     
                                                                                    <Text whiteSpace="nowrap" bg='#fff' border='1px solid #31AE87' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                                                        Router {plan?.extra}
                                                                                    </Text>
                                                                                    <Text whiteSpace="nowrap" bg='#D0F9EC' border='1px solid #31AE87' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                                                        WiFi {plan?.especial}
                                                                                    </Text>
                                                                                </Flex>
                                                                                : ''
                                                                        }
                                                                        {
                                                                            plan?.nuevo
                                                                                ? <Flex justifyContent='end' mb='3' gap='2' right='5'>
                                                                                    <Text bg='#D0F9EC' border='1px solid #31AE87' py='1' px='2' lineHeight='1' fontSize='sm' borderRadius='3px' className='Subtitle'>
                                                                                        Nuevo
                                                                                    </Text>
                                                                                </Flex>
                                                                                : ''
                                                                        }

                                                                        <Text className="Subtitle">
                                                                            Dúo Pack
                                                                        </Text>

                                                                        {/* Megas */}
                                                                        <Flex>
                                                                            <Heading className='Subtitle' size='md'>{plan.plan}</Heading>
                                                                        </Flex>

                                                                        {/* Descuento Cyber */}
                                                                        <Flex className="SemiBold" mt='4'>
                                                                            <Text className='Title' borderLeftRadius={'5px'} lineHeight='1' color='black' bg={plan?.ciberDestacado ? "#FFCFBF" : "#42E8B4"} fontSize={{ base: 'xs', md: "sm" }} px='2'>{plan.dcto} dcto</Text>
                                                                            <Text className='Title' borderRightRadius={'5px'} lineHeight='1' border={`1px solid ${plan?.ciberDestacado ? "#FFCFBF" : "#42E8B4"}`} fontSize={{ base: 'xs', md: "sm" }} px='1'>Oferta Online</Text>
                                                                        </Flex>

                                                                        {/* Precio */}
                                                                        <HStack mt="2" alignItems='flex-end' spacing="0">
                                                                            <Heading color="#002EFF" className="Subtitle" size="2xl">{plan.precio}</Heading>
                                                                            <Heading fontSize='26px' color="#002EFF" fontWeight='400' className="Subtitle">/{plan.timeOffer}</Heading>
                                                                        </HStack>

                                                                        {/* Tiempo oferta */}
                                                                        <Text mt='1' textAlign="justify" color='#66686C' className="Subtitle" dangerouslySetInnerHTML={{ __html: plan.luego }}></Text>

                                                                        {/* Button */}
                                                                        <Button
                                                                            mt="4"
                                                                            bg='#002EFF'
                                                                            color="white"
                                                                            className="SemiBold"
                                                                            w="100%"
                                                                            borderRadius='30px'
                                                                            p="6"
                                                                            border='2px solid #002EFF'
                                                                            fontSize={'lg'}
                                                                            _hover={{ border: '2px solid #002EFF', bg: 'white', color: '#002EFF' }}
                                                                            onClick={() => openSlide(false, plan)}
                                                                        >
                                                                            Lo quiero
                                                                        </Button>

                                                                        {/* Router + extensión */}
                                                                        <Box bg='#F3F5FF' borderRadius='12px' py='4' px='3' mt='4' mb={4}>
                                                                            <Text className='Title' mb='5'>Incluidos en tu plan:</Text>
                                                                            <HStack gap={15} rowGap={2} wrap="wrap">
                                                                                {
                                                                                    plan?.incluyeCero && <Image borderRadius='12px' src={plan?.incluyeCero} w='16%' />
                                                                                }
                                                                                {
                                                                                    plan?.incluyeUno && <Image borderRadius='12px' src={plan?.incluyeUno} w='16%' />
                                                                                }
                                                                                {
                                                                                    plan?.incluyeDos && <Image borderRadius='12px' src={plan?.incluyeDos} w='16%' />
                                                                                }
                                                                                {
                                                                                    plan?.incluyeTres && <Image borderRadius='12px' src={plan?.incluyeTres} w='16%' />
                                                                                }
                                                                                {
                                                                                    plan?.incluyeCuatro && <Image borderRadius='12px' src={plan?.incluyeCuatro} w='16%' />
                                                                                }
                                                                                {
                                                                                    plan?.incluyeQuinto && <Image borderRadius='12px' src={plan?.incluyeQuinto} w='16%' />
                                                                                }
                                                                                {
                                                                                    plan?.incluyeSeis && <Image borderRadius='12px' src={plan?.incluyeSeis} w='16%' />
                                                                                }
                                                                            </HStack>
                                                                        </Box>

                                                                        {/* Beneficios oferta */}
                                                                        <Box mt="4">
                                                                            <VStack
                                                                                bg='#F3F5FF'
                                                                                borderRadius='12px'
                                                                                spacing={3}
                                                                                align='stretch'
                                                                                p="3"
                                                                            >
                                                                                {
                                                                                    plan.items.map((beneficios) => (
                                                                                        <HStack spacing='10px' key={beneficios.id}>
                                                                                            <Box>
                                                                                                {beneficios.icon}
                                                                                            </Box>
                                                                                            <Text fontSize="sm" textAlign="justify" className="Subtitle" dangerouslySetInnerHTML={{ __html: beneficios.info }}></Text>
                                                                                        </HStack>
                                                                                    ))
                                                                                }
                                                                            </VStack>
                                                                        </Box>
                                                                    </Box>

                                                                    <Divider mt='1' />

                                                                    {/* Boton para ver más detalles */}
                                                                    <Box p='4'>
                                                                        <Button
                                                                            onClick={() => openToggleDetails(plan)}
                                                                            textDecoration='underline'
                                                                            className="Subtitle"
                                                                            variant="link"
                                                                            fontSize='lg'
                                                                            rightIcon={<BsChevronRight size='25px' />}
                                                                            color="#002EFF"
                                                                            fontWeight="bold"
                                                                        >
                                                                            Detalle de plan
                                                                        </Button>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </SplideSlide>
                                                    ))
                                                }
                                            </SplideTrack>
                                        </Splide>
                                    </Box>
                                </Flex>
                            </Box>
                    }
                </Box>

                <Text className='Subtitle' color='black' textAlign='center' pt={[10,10,20,20,20]} fontSize='sm' display={'block'}>
                    *Planes y precios válidos para nuevas contrataciones online hasta el 30 de noviembre de 2026.
                </Text>
                <Text className='Subtitle' color='black' textAlign='center' pb='5' fontSize='sm' display={'block'}>
                    *30% dcto. en equipos y accesorios con tope máximo $60.000. Disponible después de la instalación del servicio.
                </Text>
            </Box>

            {/* Info down */}
            <Box backgroundImage={[HogarDownMovil, HogarDownMovil, HogarDown]} backgroundSize="cover" backgroundPosition={["right", "right", "left", "left", "left"]} backgroundRepeat="no-repeat" my={[0, 0, 10, 10, 10]}>
                <Box w={['90%', '90%', '90%', '90%', '90%']} m='auto' pt={[5, 5, 20, 20, 20]}>
                    <Heading fontWeight='500' className="General" size='2xl' color='white' lineHeight='1.2'>
                        ¿Por qué contratar <br /> <b>Internet Fibra Óptica?</b>
                    </Heading>
                </Box>

                <Box w={['90%', '90%', '90%', '90%', '90%']} m='auto' pb={[8, 8, 16, 16, 16]} pt={[24, 24, 10, 10, 10]}>
                    <Splide
                        hasTrack={false}
                        options={{
                            type: 'loop',
                            perPage: 3,
                            perMove: 1,
                            pagination: true,
                            autoplay: false,
                            gap: '30px',
                            arrows: false,
                            breakpoints: {
                                840: {
                                    perPage: 2,
                                },
                                600: {
                                    perPage: 1,
                                }
                            },
                        }}
                    >
                        <SplideTrack>
                            <SplideSlide>
                                <Box bg='white' p='5' borderRadius='12px'>
                                    <IconChat color='#002EFF' size='40px' />
                                    <Heading className="Title" size='md' mt='3'>
                                        Conectividad
                                    </Heading>
                                    <Text className="General" mt='2' fontSize='lg' pr='5'>
                                        La tecnología Fibra Óptica asegura una mejor experiencia de conectividad con nuestros equipos.
                                    </Text>
                                </Box>
                            </SplideSlide>
                            <SplideSlide>
                                <Box bg='white' p='5' borderRadius='12px'>
                                    <IconNube color='#002EFF' size='40px' />
                                    <Heading className="Title" size='md' mt='3'>
                                        Estabilidad
                                    </Heading>
                                    <Text className="General" mt='2' fontSize='lg' pr='5'>
                                        La máxima calidad en servicio para jugar, navegar y ver televisión sin interrupciones ni caidas.
                                    </Text>
                                </Box>
                            </SplideSlide>
                            <SplideSlide>
                                <Box bg='white' p='5' borderRadius='12px' h='100%'>
                                    <IconDatos color='#002EFF' size='40px' />
                                    <Heading className="Title" size='md' mt='3'>
                                        Velocidad simétrica
                                    </Heading>
                                    <Text className="General" mt='2' fontSize='lg' pr='5'>
                                        Sube y descarga archivos con los mismos megas de subida y de bajada
                                    </Text>
                                </Box>
                            </SplideSlide>
                        </SplideTrack>
                    </Splide>
                </Box>
            </Box>

            {/* Drawer mostrar detalle completo */}
            <Drawer
                isOpen={isOpen}
                size={isMobile ? 'full' : seccionView === 'internet' ? 'sm' : 'md'}
                onClose={onClose}
            >
                <DrawerOverlay bg='rgba(53, 52, 68, 0.7)' />
                <DrawerContent>
                    <DrawerBody>
                        {
                            seccionView === 'internet'
                                ? dataDrawer?.id
                                    ? <>
                                        <Flex alignItems='start' mt='5'>
                                            <Box>
                                                <Heading fontWeight='400' className='General' size='lg'>
                                                    Internet
                                                </Heading>
                                                <Heading className='Subtitle' size='lg' lineHeight='1'>
                                                    Fibra {dataDrawer?.megas.replace('Megas', '')}
                                                </Heading>
                                            </Box>
                                            <Spacer />
                                            <IconButton color='#002eff' onClick={onClose} variant='link' icon={<AiOutlineClose size='35px' />} _focusVisible={{}} _active={{}} _focus={{}} />
                                        </Flex>
                                        {
                                            dataDrawer.icon !== '' && <Box mt='3'>
                                                <HStack>
                                                    {dataDrawer.icon}
                                                    <Text className='Subtitle'>{dataDrawer?.infoIcon}</Text>
                                                </HStack>
                                                <Text className='Subtitle' mb='3' dangerouslySetInnerHTML={{ __html: dataDrawer?.texto }}>
                                                </Text>
                                                {/* <Text color='#002EFF' textDecoration='underline'>{dataDrawer.link}</Text> */}
                                            </Box>
                                        }
                                        <Accordion defaultIndex={[indexDrawer]} allowToggle>
                                            <AccordionItem mt='4' borderColor='#66686C'>
                                                {({ isExpanded }) => (
                                                    <>
                                                        <AccordionButton p='4'>
                                                            <Box as="span" flex='1' textAlign='left'>
                                                                <HStack>
                                                                    <IconVelocidad size='25' />
                                                                    <Text className='Title'>Velocidad de navegación</Text>
                                                                </HStack>
                                                            </Box>
                                                            {
                                                                isExpanded
                                                                    ? <IconArrowUp />
                                                                    : <IconArrowDown />
                                                            }
                                                        </AccordionButton>
                                                        <AccordionPanel pb={4}>
                                                            <Box>
                                                                <Text className='Subtitle'>Ideal para:</Text>
                                                                {
                                                                    dataDrawer?.infoPlus?.length > 0 && dataDrawer?.infoPlus.map((infoPlus) => (
                                                                        <HStack mt='4' key={infoPlus?.id}>
                                                                            <Box w='25px' h='25px'>
                                                                                {infoPlus?.icon}
                                                                            </Box>
                                                                            <Text>{infoPlus?.text}</Text>
                                                                        </HStack>
                                                                    ))
                                                                }
                                                            </Box>

                                                            <VStack spacing='5' my='5'>
                                                                <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                                    <Text className='Title'>
                                                                        Velocidad Nacional
                                                                    </Text>

                                                                    <Text className='General' mt='2'>
                                                                        Es la rapidez del intercambio de datos entre un dispositivo y un servidor
                                                                        de medición que está en Chile.
                                                                    </Text>

                                                                    <Box border='1px solid #002EFF' mt='3' bg='#F3F5FF' p='3' borderRadius='7px'>
                                                                        <Flex fontSize='sm'>
                                                                            <Text className='Regular' fontWeight='600'>{dataDrawer?.megasUpAndDown}</Text>
                                                                            <Spacer />
                                                                            <Text>Máximo contratado</Text>
                                                                        </Flex>
                                                                        <Divider borderColor='#002EFF' my='2' />
                                                                        <Flex fontSize='sm'>
                                                                            <Text className='Regular' fontWeight='600'>50 Mbps</Text>
                                                                            <Spacer />
                                                                            <Text>Mínimo garantizado</Text>
                                                                        </Flex>
                                                                    </Box>
                                                                </Box>
                                                                <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                                    <Text className='Title'>
                                                                        Velocidad Internacional
                                                                    </Text>

                                                                    <Text className='General' mt='2'>
                                                                        Es la rapidez del intercambio de datos entre un dispositivo y un servidor
                                                                        de medición que está fuera del territorio nacional.
                                                                    </Text>

                                                                    <Box border='1px solid #002EFF' mt='3' bg='#F3F5FF' p='3' borderRadius='7px'>
                                                                        <Flex fontSize='sm'>
                                                                            <Text className='Regular' fontWeight='600'>{dataDrawer?.megasUpAndDown}</Text>
                                                                            <Spacer />
                                                                            <Text>Máximo contratado</Text>
                                                                        </Flex>
                                                                        <Divider borderColor='#002EFF' my='2' />
                                                                        <Flex fontSize='sm'>
                                                                            <Text className='Regular' fontWeight='600'>50 Mbps</Text>
                                                                            <Spacer />
                                                                            <Text>Mínimo garantizado</Text>
                                                                        </Flex>
                                                                    </Box>
                                                                </Box>

                                                                <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                                    <Text className='Title'>
                                                                        Velocidad mínima garantizada
                                                                    </Text>

                                                                    <Text className='General' mt='2'>
                                                                        <b>Aplica de subida y de bajada</b> para todos los horarios con alta
                                                                        y baja congestión de red.
                                                                    </Text>
                                                                </Box>
                                                            </VStack>

                                                            <Flex bg='#F3F5FF' p='2' mt='5'>
                                                                <Box m='auto'>
                                                                    <IconInfo size='30px' />
                                                                </Box>
                                                                <Text ml='3' className='Subtitle' fontSize='sm' lineHeight='1'>
                                                                    Si al contratar recibes una velocidad menor a tu plan, llámanos al <b>600 3600 103, opción 2.</b>
                                                                </Text>
                                                            </Flex>
                                                        </AccordionPanel>
                                                    </>
                                                )}
                                            </AccordionItem>

                                            <AccordionItem borderColor='#66686C'>
                                                {({ isExpanded }) => (
                                                    <>
                                                        <AccordionButton p='4'>
                                                            <Box as="span" flex='1' textAlign='left'>
                                                                <HStack>
                                                                    <IconExtensor size='25' />
                                                                    <Text className='Title' fontSize='lg'>Extensor {dataDrawer?.id === 3  ? 'WiFi 7' : dataDrawer?.id === 4 && 'WiFi 7' }</Text>
                                                                </HStack>
                                                            </Box>
                                                            {
                                                                isExpanded
                                                                    ? <IconArrowUp />
                                                                    : <IconArrowDown />
                                                            }
                                                        </AccordionButton>
                                                        <AccordionPanel pb={4}>
                                                            <Divider h='1px' />
                                                            <Text className='Subtitle' my='3'>
                                                                Incluye <b>hasta {dataDrawer.extensor} {dataDrawer.infoExtensor}</b> según
                                                                evaluación técnica
                                                            </Text>
                                                            <Text className='Title'>¿Qué es un extensor Wifi {dataDrawer?.id === 3  ? '7' : dataDrawer?.id === 4  && '7'}?</Text>

                                                            {
                                                                dataDrawer?.id === 3 
                                                                ? <>
                                                                    <Text className='Subtitle'>
                                                                        La nueva generación de WiFi que ofrece más velocidad, menor latencia y máxima 
                                                                        estabilidad para todos los dispositivos, incluso en los usos más exigentes.
                                                                    </Text>
                                                                </>
                                                                : <>
                                                                    <Text className='Subtitle'>
                                                                        Es un dispositivo que mejora tu experiencia de navegación
                                                                    </Text>
                                                                    <Text className='Subtitle'>
                                                                        ¡Mayor cobertura, estabilidad y velocidad dentro de tu hogar!
                                                                    </Text>
                                                                </>
                                                            }
                                                            <Text className='Title' mt='3'>
                                                                Con {dataDrawer.extensor} {dataDrawer.extensor === 1 ? ' extensor ' : ' extensores '}
                                                                podrás tener {dataDrawer.puntosInternet} puntos de Internet en tu Hogar.
                                                            </Text>
                                                            <Text className='Subtitle'>
                                                                Puedes arrendar más extensores por solo $2.990/mes cada uno(máximo 4 extensores por cliente).
                                                            </Text>
                                                            <Divider h='1px' my='3' />
                                                            <Text className='Title'>Beneficios de uso de extensor WiFi {dataDrawer?.id === 3 ? '7' : dataDrawer?.id === 4 ? '7' : '6'}:</Text>
                                                            <HStack mt='4'>
                                                                <Box w='25px' h='25px'>
                                                                    <IconHogarNew size='25px' />
                                                                </Box>
                                                                <Text>
                                                                    {
                                                                        dataDrawer?.id === 3
                                                                        ? 'Aprovecha al máximo los planes de alta velocidad, evitando que la red se convierta en un cuello de botella.'
                                                                        : dataDrawer?.id === 4
                                                                        ? 'Aprovecha al máximo los planes de alta velocidad, evitando que la red se convierta en un cuello de botella.' 
                                                                        : 'WiFi de alta velocidad, mayor cobertura y estabilidad dentro de tu hogar, a pesar de la cantidad de dispositivos conectados'
                                                                    }
                                                                </Text>
                                                            </HStack>
                                                            <HStack mt='4'>
                                                                <Box w='25px' h='25px'>
                                                                    <IconCorazon size='25px' />
                                                                </Box>
                                                                <Text>
                                                                    {
                                                                        dataDrawer?.id === 3
                                                                        ? 'cortes y aplicaciones en tiempo real. Las acciones responden de forma inmediata.'
                                                                        : dataDrawer?.id === 4
                                                                        ? 'cortes y aplicaciones en tiempo real. Las acciones responden de forma inmediata.' 
                                                                        : 'Estéticamente amigables con la decoración del hogar'
                                                                    }
                                                                </Text>
                                                            </HStack>
                                                            <HStack mt='4'>
                                                                <Box w='25px' h='25px'>
                                                                    <IconComunidad size='25px' />
                                                                </Box>
                                                                <Text>
                                                                    {
                                                                        dataDrawer?.id === 3
                                                                        ? 'La red se adapta de forma inteligente para mantener una conexión fluida, incluso con muchos dispositivos conectados al mismo tiempo.'
                                                                        : dataDrawer?.id === 4
                                                                        ? 'La red se adapta de forma inteligente para mantener una conexión fluida, incluso con muchos dispositivos conectados al mismo tiempo.' 
                                                                        : 'Una sola red, los distintos dispositivos se conectan automáticamentea la red óptima'
                                                                    }
                                                                </Text>
                                                            </HStack>
                                                            <HStack mt='4'>
                                                                <Box w='25px' h='25px'>
                                                                    <IconSeguridad size='25px' />
                                                                </Box>
                                                                <Text>
                                                                    {
                                                                        dataDrawer?.id === 3
                                                                        ? 'Todos los dispositivos funcionan mejor, al mismo tiempo, sin caídas de calidad.'
                                                                        :  dataDrawer?.id === 4
                                                                        ? 'Todos los dispositivos funcionan mejor, al mismo tiempo, sin caídas de calidad.'
                                                                        : 'Dualband, red 2.4 y 5 GHZ, en una sola red'
                                                                    }
                                                                </Text>
                                                            </HStack>
                                                            
                                                            {
                                                                dataDrawer?.id === 3
                                                                ? ''
                                                                : dataDrawer?.id === 4 
                                                                    ? ''
                                                                    : <Flex bg='#F3F5FF' p='2' my='4'>
                                                                        <Box w='25px' h='25px'>
                                                                            <IconInfo size='25px' />
                                                                        </Box>
                                                                        <Text ml='3' className='Subtitle'>
                                                                            Recuerdaque la evaluación técnica de los extensores es para garantizar una mejor experiencia de internet en tu hogar.
                                                                        </Text>
                                                                    </Flex>
                                                            }
                                                        </AccordionPanel>
                                                    </>
                                                )}
                                            </AccordionItem>
                                        </Accordion>

                                        {
                                            planSelected === 2 && <Box mb='20'>
                                                <Text className='Title'>Este pack incluye:</Text>
                                                <Flex alignItems='center' mt='3'>
                                                    <Box h='10px' mr='3' bg='#002EFF' borderRadius='50%' w='10px'></Box>
                                                    <Text className='Subtitle' fontSize='sm'>
                                                        Suscripción a <b>Disney+ Premium.</b>
                                                    </Text>
                                                </Flex>
                                            </Box>
                                        }

                                        {
                                            dataDrawer?.id === 4 && <Box mb='20'>
                                                <Text className='Title'>Este pack incluye:</Text>
                                                <Flex alignItems='center' mt='3'>
                                                    <Box h='10px' mr='3' bg='#002EFF' borderRadius='50%' w='10px'></Box>
                                                    <Text className='Subtitle' fontSize='sm'>
                                                        <b>Incluye hasta 1 extensor WiFi 7</b> según evaluación técninca.
                                                    </Text>
                                                </Flex>
                                                <Flex alignItems='center' mt='3'>
                                                    <Box h='10px' mr='3' bg='#002EFF' borderRadius='full' w='24px'></Box>
                                                    <Text className='Subtitle' fontSize='sm'>
                                                        <b>Instalación sin costo en 24 h.</b> Puedes agendar el día y la hora.
                                                        Tiene un tiempo de duración de 4 h aproximadamente. (Sujeto a disponibilidad).
                                                    </Text>
                                                </Flex>
                                            </Box>
                                        }

                                        {
                                            dataDrawer?.id === 4
                                            ? <Flex bg='#F3F5FF' p='2' mb={planSelected === 2 ? '5' : '20'} mt='5'>
                                                <Box m='auto'>
                                                    <IconInfo size='30px' />
                                                </Box>
                                                <Text ml='3' className='Subtitle' fontSize='sm' lineHeight='1'>
                                                    <b>Plan 2 Gigas</b><br />
                                                    Plan con cobertura limitada por infraestructura de red. Verifica disponibilidad para tu comuna
                                                </Text>
                                            </Flex>
                                            : <Flex bg='#F3F5FF' p='2' mb={planSelected === 2 ? '5' : '20'} mt='5'>
                                                <Box m='auto'>
                                                    <IconInfo size='30px' />
                                                </Box>
                                                <Text ml='3' className='Subtitle' fontSize='sm' lineHeight='1'>
                                                    La instalación toma como máximo 4 horas aprox. Puedes agendar
                                                    día y hora al contratar. <b>Inlación costo $0.</b>
                                                </Text>
                                            </Flex>
                                        }

                                        <Flex justifyContent='end' mt='5' bg='white' w='100%' position='fixed' bottom='0' p='3'>
                                            <Button
                                                mr='10'
                                                bg='#002EFF'
                                                px='20'
                                                onClick={() => { onClose(); openSlide(false, dataPlanDrawer) }}
                                                borderRadius='30px'
                                                _hover={{ bg: 'transparent', color: '#002EFF' }}
                                                border='2px solid #002EFF'
                                                color='white'
                                                className='Subtitle'
                                            >
                                                Lo quiero
                                            </Button>
                                        </Flex>
                                    </>
                                    : <>
                                        <Flex alignItems='start' mt='5'>
                                            <Box>
                                                <Heading fontWeight='400' className='General' size='lg'>
                                                    Internet
                                                </Heading>
                                                <Heading className='Subtitle' size='lg' lineHeight='1'>
                                                    Fibra 600{planSelected === 2 ? '+' : ''}
                                                </Heading>
                                            </Box>
                                            <Spacer />
                                            <IconButton color='#002eff' onClick={onClose} variant='link' icon={<AiOutlineClose size='35px' />} _focusVisible={{}} _active={{}} _focus={{}} />
                                        </Flex>

                                        <Box mt='3'>
                                            <HStack>
                                                <IconRouter />
                                                <Text className='Subtitle'>¿Qué es WiFi 6?</Text>
                                            </HStack>
                                            <Text className='Subtitle' mb='3'>
                                                Tecnología que te ofrece una <b>navegación más rápida, estable y eficiente</b> incluso cuando todos están usando internet.
                                            </Text>
                                        </Box>

                                        <HStack my='5'>
                                            <IconVelocidad size='25px' />
                                            <Text className='Subtitle' fontWeight='600' fontSize='lg'>Velocidad de navegación</Text>
                                        </HStack>

                                        <Box>
                                            <Text className='Subtitle'>Ideal para:</Text>
                                            <HStack mt='4'>
                                                <Box w='25px' h='25px'>
                                                    <IconEquipo color='#002EFF' size='20px' />
                                                </Box>
                                                <Text>Conectar hasta 7-8 dispositivos simultáneamente</Text>
                                            </HStack>
                                            <HStack mt='4'>
                                                <Box w='25px' h='25px'>
                                                    <IconUnion sizeW='22px' />
                                                </Box>
                                                <Text>Descargar archivos rápidamente</Text>
                                            </HStack>
                                            <HStack mt='4'>
                                                <Box w='25px' h='25px'>
                                                    <IconUsuarios size='20px' />
                                                </Box>
                                                <Text>Trabajar y estudiar a distancia</Text>
                                            </HStack>
                                            <HStack mt='4'>
                                                <Box w='25px' h='25px'>
                                                    <IconTv size='20px' />
                                                </Box>
                                                <Text>Ver peliculas y series en HD</Text>
                                            </HStack>
                                            <HStack mt='4'>
                                                <Box w='25px' h='25px'>
                                                    <IconGamer size='20px' />
                                                </Box>
                                                <Text>Jugar en linea</Text>
                                            </HStack>
                                        </Box>

                                        <VStack spacing='5' my='5'>
                                            <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                <Text className='Title'>
                                                    Velocidad Nacional
                                                </Text>

                                                <Text className='General' mt='2'>
                                                    Es la rapidez del intercambio de datos entre un dispositivo y un servidor
                                                    de medición que está en Chile.
                                                </Text>

                                                <Box border='1px solid #002EFF' mt='3' bg='#F3F5FF' p='3' borderRadius='7px'>
                                                    <Flex fontSize='sm'>
                                                        <Text className='Regular' fontWeight='600'>600 Mbps</Text>
                                                        <Spacer />
                                                        <Text>Máximo contratado</Text>
                                                    </Flex>
                                                    <Divider borderColor='#002EFF' my='2' />
                                                    <Flex fontSize='sm'>
                                                        <Text className='Regular' fontWeight='600'>50 Mbps</Text>
                                                        <Spacer />
                                                        <Text>Mínimo garantizado</Text>
                                                    </Flex>
                                                </Box>
                                            </Box>
                                            <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                <Text className='Title'>
                                                    Velocidad Internacional
                                                </Text>

                                                <Text className='General' mt='2'>
                                                    Es la rapidez del intercambio de datos entre un dispositivo y un servidor
                                                    de medición que está fuera del territorio nacional.
                                                </Text>

                                                <Box border='1px solid #002EFF' mt='3' bg='#F3F5FF' p='3' borderRadius='7px'>
                                                    <Flex fontSize='sm'>
                                                        <Text className='Regular' fontWeight='600'>600 Mbps</Text>
                                                        <Spacer />
                                                        <Text>Máximo contratado</Text>
                                                    </Flex>
                                                    <Divider borderColor='#002EFF' my='2' />
                                                    <Flex fontSize='sm'>
                                                        <Text className='Regular' fontWeight='600'>50 Mbps</Text>
                                                        <Spacer />
                                                        <Text>Mínimo garantizado</Text>
                                                    </Flex>
                                                </Box>
                                            </Box>

                                            <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                <Text className='Title'>
                                                    Velocidad mínima garantizada
                                                </Text>

                                                <Text className='General' mt='2'>
                                                    <b>Aplica de subida y de bajada</b> para todos los horarios con alta
                                                    y baja congestión de red.
                                                </Text>
                                            </Box>
                                        </VStack>

                                        <Flex bg='#F3F5FF' p='2' mb={planSelected === 2 ? '5' : '20'} mt='5'>
                                            <Box m='auto'>
                                                <IconInfo size='30px' />
                                            </Box>
                                            <Text ml='3' className='Subtitle' fontSize='sm' lineHeight='1'>
                                                Si al contratar recibes una velocidad menor a tu plan, llámanos al <b>600 3600 103, opción 2</b>
                                            </Text>
                                        </Flex>

                                        {
                                            planSelected === 2 && <Box mb='20'>
                                                <Text className='Title'>Este pack incluye:</Text>
                                                <Flex alignItems='center' mt='3'>
                                                    <Box h='10px' mr='3' bg='#002EFF' borderRadius='50%' w='10px'></Box>
                                                    <Text className='Subtitle' fontSize='sm'>
                                                        Suscripción a <b>Disney+ Premium.</b>
                                                    </Text>
                                                </Flex>
                                            </Box>
                                        }

                                        <Flex justifyContent='end' mt='5' bg='white' w='100%' position='fixed' bottom='0' p='3'>
                                            <Button
                                                mr='10'
                                                bg='#002EFF'
                                                px='10'
                                                borderRadius='30px'
                                                onClick={() => { onClose(); openSlide(false, dataPlanDrawer) }}
                                                _hover={{ bg: 'transparent', color: '#002EFF' }}
                                                border='2px solid #002EFF'
                                                color='white'
                                                className='Subtitle'
                                            >
                                                Lo quiero
                                            </Button>
                                        </Flex>
                                    </>
                                : <>
                                    <Flex alignItems='start' mt='5'>
                                        <Box>
                                            <Text fontSize='3xl' lineHeight='1' className='General'>Dúo Pack</Text>
                                            <Text fontSize='3xl' lineHeight='1' className='General'><b>Fibra {dataDrawer?.megas} {dataDrawer?.plan}</b></Text>
                                        </Box>
                                        <Spacer />
                                        <IconButton color='#002eff' onClick={onClose} variant='link' icon={<AiOutlineClose size='35px' />} _focusVisible={{}} _active={{}} _focus={{}} />
                                    </Flex>

                                    {
                                        dataDrawer?.description &&
                                        <Box mt='3'>
                                            <Flex alignItems='center'>
                                                {dataDrawer?.icon}
                                                <Text className='General' ml='2' dangerouslySetInnerHTML={{ __html: dataDrawer?.name }}></Text>
                                            </Flex>

                                            <Text className='General' mt='3' dangerouslySetInnerHTML={{ __html: dataDrawer?.description }}></Text>
                                        </Box>
                                    }

                                    <Accordion defaultIndex={[indexDrawer]} allowToggle mt='5'>
                                        <AccordionItem>
                                            {({ isExpanded }) => (
                                                <>
                                                    <AccordionButton>
                                                        <Box as="span" flex='1' textAlign='left' py='2'>
                                                            <HStack>
                                                                {dataDrawer?.beneficioUno?.icon}
                                                                <Text className='Title' fontSize='xl'>{dataDrawer?.beneficioUno?.name}</Text>
                                                            </HStack>
                                                        </Box>
                                                        {
                                                            isExpanded
                                                                ? <IconArrowUp color='#A4A4A6' />
                                                                : <IconArrowDown color='#A4A4A6' />
                                                        }
                                                    </AccordionButton>
                                                    <AccordionPanel pb={4}>
                                                        <Box>
                                                            <Text fontWeight='bold' className='Subtitle'>Ideal para:</Text>
                                                            <List spacing={3} mt='2'>
                                                                {
                                                                    dataDrawer?.beneficioUno?.content?.ideal?.map((ideal) => (
                                                                        <ListItem key={ideal?.id} display='flex' alignItems='center'>
                                                                            {ideal.icon}
                                                                            <Text ml='3' className='Subtitle' dangerouslySetInnerHTML={{ __html: ideal.name }}></Text>
                                                                        </ListItem>
                                                                    ))
                                                                }

                                                            </List>
                                                        </Box>
                                                        <VStack spacing='5' my='5'>
                                                            <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                                <Text className='Title'>
                                                                    Velocidad Nacional
                                                                </Text>

                                                                <Text className='General' mt='2'>
                                                                    Es la rapidez del intercambio de datos entre un dispositivo y un servidor
                                                                    de medición que está en Chile.
                                                                </Text>

                                                                <Box border='1px solid #002EFF' mt='3' bg='#F3F5FF' p='3' borderRadius='7px'>
                                                                    <Flex fontSize='sm'>
                                                                        <Text className='Regular' fontWeight='600'>{dataDrawer?.beneficioUno?.content?.megas}</Text>
                                                                        <Spacer />
                                                                        <Text>Máximo contratado</Text>
                                                                    </Flex>
                                                                    <Divider borderColor='#002EFF' my='2' />
                                                                    <Flex fontSize='sm'>
                                                                        <Text className='Regular' fontWeight='600'>50 Mbps</Text>
                                                                        <Spacer />
                                                                        <Text>Mínimo garantizado</Text>
                                                                    </Flex>
                                                                </Box>
                                                            </Box>
                                                            <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                                <Text className='Title'>
                                                                    Velocidad Internacional
                                                                </Text>

                                                                <Text className='General' mt='2'>
                                                                    Es la rapidez del intercambio de datos entre un dispositivo y un servidor
                                                                    de medición que está fuera del territorio nacional.
                                                                </Text>

                                                                <Box border='1px solid #002EFF' mt='3' bg='#F3F5FF' p='3' borderRadius='7px'>
                                                                    <Flex fontSize='sm'>
                                                                        <Text className='Regular' fontWeight='600'>{dataDrawer?.beneficioUno?.content?.megas}</Text>
                                                                        <Spacer />
                                                                        <Text>Máximo contratado</Text>
                                                                    </Flex>
                                                                    <Divider borderColor='#002EFF' my='2' />
                                                                    <Flex fontSize='sm'>
                                                                        <Text className='Regular' fontWeight='600'>50 Mbps</Text>
                                                                        <Spacer />
                                                                        <Text>Mínimo garantizado</Text>
                                                                    </Flex>
                                                                </Box>
                                                            </Box>

                                                            <Box boxShadow='0px 0px 2px 0px #CACACA' borderRadius='15px' p='3'>
                                                                <Text className='Title'>
                                                                    Velocidad mínima garantizada
                                                                </Text>

                                                                <Text className='General' mt='2'>
                                                                    <b>Aplica de subida y de bajada</b> para todos los horarios con alta
                                                                    y baja congestión de red.
                                                                </Text>
                                                            </Box>
                                                        </VStack>

                                                        <Flex bg='#F3F5FF' p='2' my='5'>
                                                            <Box m='auto'>
                                                                <IconInfo size='30px' />
                                                            </Box>
                                                            <Text ml='3' className='Subtitle' fontSize='sm'>
                                                                Si al contratar recibes una velocidad menor a tu plan, llámanos al <b>600 3600 103, opción 2</b>
                                                            </Text>
                                                        </Flex>
                                                    </AccordionPanel>
                                                </>
                                            )}
                                        </AccordionItem>

                                        <AccordionItem>
                                            {({ isExpanded }) => (
                                                <>
                                                    <AccordionButton>
                                                        <Box as="span" flex='1' textAlign='left' py='2'>
                                                            <HStack>
                                                                {dataDrawer?.beneficioDos?.icon}
                                                                <Text className='Title' fontSize='xl'>{dataDrawer?.beneficioDos?.name}</Text>
                                                            </HStack>
                                                        </Box>
                                                        {
                                                            isExpanded
                                                                ? <IconArrowUp color='#A4A4A6' />
                                                                : <IconArrowDown color='#A4A4A6' />
                                                        }
                                                    </AccordionButton>
                                                    <AccordionPanel pb={4}>
                                                        <Heading color='#002EFF' className='Title' size='xl'>{dataDrawer?.beneficioDos?.content?.canales}</Heading>
                                                        <Text className='Subtitle' fontWeight='bold'>{dataDrawer?.beneficioDos?.content?.desglose}</Text>

                                                        <Text className='Subtitle' mt='3' dangerouslySetInnerHTML={{ __html: dataDrawer?.beneficioDos?.content?.description }}></Text>
                                                        <Divider my='4' borderWidth='1px' />
                                                        <Text className='Subtitle' dangerouslySetInnerHTML={{ __html: dataDrawer?.beneficioDos?.content?.info }}></Text>

                                                        <List spacing={3} mt='2'>
                                                            {
                                                                dataDrawer?.beneficioDos?.content?.incluye?.map((incluye) => (
                                                                    <ListItem key={incluye?.id} display='flex' alignItems='center'>
                                                                        {incluye.icon}
                                                                        <Text ml='2' className='Subtitle' dangerouslySetInnerHTML={{ __html: incluye.name }}></Text>
                                                                    </ListItem>
                                                                ))
                                                            }
                                                        </List>

                                                        <Box>
                                                            <Text className='Subtitle' mt='5' fontWeight='bold'>
                                                                Acceso a información de red Wi-Fi (SSID)
                                                            </Text>

                                                            <Text className='General'>
                                                                La aplicación Entel TV accede a la información de la red Wi-
                                                                Fi del dispositivo (nombre de la red o SSID) únicamente para:
                                                            </Text>

                                                            <UnorderedList spacing='1' mt='3'>
                                                                <ListItem>Mejorar la calidad del servicio y la experiencia del usuario mediante herramientas de monitoreo.</ListItem>
                                                                <ListItem>Mostrar el nombre de la red en la pantalla de configuración de la aplicación.</ListItem>
                                                            </UnorderedList>

                                                            <Text className='General'>Esta información no se utiliza para determinar la ubicación geográfica del usuario ni se comparte con terceros con fines publicita.</Text>
                                                        </Box>

                                                        <Flex bg='#F3F5FF' px='2' py='3' my='5' border='1px solid #002EFF' borderRadius='5px'>
                                                            <Box>
                                                                <IconInfo size='25px' />
                                                            </Box>
                                                            <Text ml='3' className='General' lineHeight='1' fontSize='sm'>
                                                                Recuerda que la evaluación técnica de los extensores es para garantizar una mejor experiencia de internet en tu hogar
                                                            </Text>
                                                        </Flex>
                                                    </AccordionPanel>
                                                </>
                                            )}
                                        </AccordionItem>

                                        {
                                            dataDrawer?.beneficioTres &&
                                            <AccordionItem>
                                                {({ isExpanded }) => (
                                                    <>
                                                        <AccordionButton>
                                                            <Box as="span" flex='1' textAlign='left' py='2'>
                                                                <HStack>
                                                                    {dataDrawer?.beneficioTres?.icon}
                                                                    <Text className='Title' fontSize='xl'>{dataDrawer?.beneficioTres?.name}</Text>
                                                                </HStack>
                                                            </Box>
                                                            {
                                                                isExpanded
                                                                    ? <IconArrowUp color='#A4A4A6' />
                                                                    : <IconArrowDown color='#A4A4A6' />
                                                            }
                                                        </AccordionButton>
                                                        <AccordionPanel pb={4}>
                                                            <Text color='#002EFF' className='Subtitle' fontWeight='bold'>{dataDrawer?.beneficioTres?.content?.incluye}</Text>

                                                            <Text className='General' mt='4' dangerouslySetInnerHTML={{ __html: dataDrawer?.beneficioTres?.content?.description }}></Text>

                                                            <Text color='#002EFF' className='Subtitle' mt='4' fontWeight='bold'>{dataDrawer?.beneficioTres?.content?.titleBeneficios}</Text>

                                                            <List spacing={3} mt='2'>
                                                                {
                                                                    dataDrawer?.beneficioTres?.content?.beneficios?.map((beneficio) => (
                                                                        <ListItem key={beneficio?.id} display='flex' alignItems='center'>
                                                                            {beneficio.icon}
                                                                            <Text ml='2' className='General' dangerouslySetInnerHTML={{ __html: beneficio.name }}></Text>
                                                                        </ListItem>
                                                                    ))
                                                                }
                                                            </List>

                                                            <Flex bg='#F3F5FF' px='2' py='3' my='5' border='1px solid #002EFF' borderRadius='5px'>
                                                                <Box>
                                                                    <IconInfo size='25px' />
                                                                </Box>
                                                                <Text ml='3' className='General' lineHeight='1' fontSize='sm'>
                                                                    Recuerda que la evaluación técnica de los extensores es para garantizar una mejor experiencia de internet en tu hogar.
                                                                </Text>
                                                            </Flex>
                                                        </AccordionPanel>
                                                    </>
                                                )}
                                            </AccordionItem>
                                        }

                                        {
                                            dataDrawer?.beneficioCuatro &&
                                            <AccordionItem>
                                                {({ isExpanded }) => (
                                                    <>
                                                        <AccordionButton>
                                                            <Box as="span" flex='1' textAlign='left' py='2'>
                                                                <HStack>
                                                                    {dataDrawer?.beneficioCuatro?.icon}
                                                                    <Text className='Title' fontSize='xl'>{dataDrawer?.beneficioCuatro?.name}</Text>
                                                                </HStack>
                                                            </Box>
                                                            {
                                                                isExpanded
                                                                    ? <IconArrowUp color='#A4A4A6' />
                                                                    : <IconArrowDown color='#A4A4A6' />
                                                            }
                                                        </AccordionButton>
                                                        <AccordionPanel pb={4}>
                                                            <Text color='#002EFF' className='Subtitle' fontWeight='bold'>{dataDrawer?.beneficioCuatro?.content?.incluye}</Text>

                                                            <Text className='General' mt='4' dangerouslySetInnerHTML={{ __html: dataDrawer?.beneficioCuatro?.content?.description }}></Text>

                                                            <Text color='#002EFF' className='Subtitle' mt='4' fontWeight='bold'>Beneficios de uso de extensor WiFi 6:</Text>

                                                            <List spacing={3} mt='2'>
                                                                {
                                                                    dataDrawer?.beneficioCuatro?.content?.beneficios?.map((beneficio) => (
                                                                        <ListItem key={beneficio?.id} display='flex' alignItems='center'>
                                                                            {beneficio.icon}
                                                                            <Text ml='2' className='General' dangerouslySetInnerHTML={{ __html: beneficio.name }}></Text>
                                                                        </ListItem>
                                                                    ))
                                                                }
                                                            </List>
                                                        </AccordionPanel>
                                                    </>
                                                )}
                                            </AccordionItem>
                                        }
                                    </Accordion>

                                    <Box>
                                        <Text className='Subtitle' mt='5' fontWeight='bold'>
                                            Este pack incluye:
                                        </Text>

                                        <UnorderedList spacing='1' mt='3'>
                                            {
                                                dataDrawer?.incluye?.map((incluye) => (
                                                    <ListItem key={incluye?.id} dangerouslySetInnerHTML={{ __html: incluye?.name }}></ListItem>
                                                ))
                                            }
                                        </UnorderedList>
                                        
                                        {
                                            dataDrawer?.megas === '2 Giga'
                                            ? <Flex bg='#F3F5FF' px='2' py='3' my='5' border='1px solid #002EFF' borderRadius='5px'>
                                                <Box>
                                                    <IconInfo size='25px' />
                                                </Box>
                                                <Text ml='3' className='General' lineHeight='1' fontSize='sm'>
                                                    <b>Plan 2 Gigas</b><br />
                                                    Plan con cobertura limitada por infraestructura de red. Verifica disponibilidad para tu comuna.
                                                </Text>
                                            </Flex>
                                            : <Flex bg='#F3F5FF' px='2' py='3' my='5' border='1px solid #002EFF' borderRadius='5px'>
                                                <Box>
                                                    <IconInfo size='25px' />
                                                </Box>
                                                <Text ml='3' className='General' lineHeight='1' fontSize='sm'>
                                                    La instalación toma como máximo 4 horas aprox. Puedes agendar
                                                    día y hora al contratar.
                                                </Text>
                                            </Flex>
                                        }

                                        <Text className='Subtitle' mt='5' fontSize='lg'>
                                            Productos adicionales a tu plan:
                                        </Text>
                                    </Box>

                                    <Accordion allowToggle mt='5'>
                                        {/* <AccordionItem>
                                        {({ isExpanded }) => (
                                            <>
                                                <AccordionButton>
                                                    <Box as="span" flex='1' textAlign='left' py='2'>
                                                        <HStack>
                                                            {dataDrawer?.adicionalesUno?.icon}
                                                            <Text className='Title' fontSize='xl'>{dataDrawer?.adicionalesUno?.name}</Text>
                                                        </HStack>
                                                    </Box>
                                                    {
                                                        isExpanded 
                                                        ? <IconArrowUp color='#A4A4A6' />
                                                        : <IconArrowDown color='#A4A4A6' />
                                                    }
                                                </AccordionButton>
                                                <AccordionPanel pb={4}>
                                                    <Text className='Subtitle' dangerouslySetInnerHTML={{__html:dataDrawer?.adicionalesUno?.content?.description}}></Text>
                                                    <Text fontWeight='bold' fontSize='xl' className='Title' my='4'>{dataDrawer?.adicionalesUno?.content?.precio}</Text>
                                                    
                                                    <List spacing={3} mt='2'>
                                                        {
                                                            dataDrawer?.adicionalesUno?.content?.info?.map((info) => (
                                                                <ListItem key={info?.id} display='flex' alignItems='center'>
                                                                    {info.icon}
                                                                    <Text ml='2' className='Subtitle' dangerouslySetInnerHTML={{__html:info.name}}></Text>
                                                                </ListItem>
                                                            ))
                                                        }
                                                    </List>
                                                    
                                                </AccordionPanel>
                                            </>
                                        )}
                                    </AccordionItem> */}

                                        <AccordionItem mb='20'>
                                            {({ isExpanded }) => (
                                                <>
                                                    <AccordionButton>
                                                        <Box as="span" flex='1' textAlign='left' py='2'>
                                                            <HStack>
                                                                {dataDrawer?.adicionalesDos?.icon}
                                                                <Text className='Subtitle' dangerouslySetInnerHTML={{ __html: dataDrawer?.adicionalesDos?.name }} fontSize='xl'></Text>
                                                            </HStack>
                                                        </Box>
                                                        {
                                                            isExpanded
                                                                ? <IconArrowUp color='#A4A4A6' />
                                                                : <IconArrowDown color='#A4A4A6' />
                                                        }
                                                    </AccordionButton>
                                                    <AccordionPanel pb={4}>
                                                        <Text dangerouslySetInnerHTML={{ __html: dataDrawer?.adicionalesDos?.content?.description }}></Text>
                                                        <Flex justifyContent='center' my='5' alignItems='center'>
                                                            {
                                                                dataDrawer?.adicionalesDos?.content?.logos?.map((image, i) => (
                                                                    <Image key={image?.id} src={image?.logo} w={i == 0 ? '30%' : '43%'} mx='2' h='100%' />
                                                                ))
                                                            }
                                                        </Flex>
                                                        <Text fontSize='sm' className='General'>{dataDrawer?.adicionalesDos?.content?.tyt}</Text>
                                                    </AccordionPanel>
                                                </>
                                            )}
                                        </AccordionItem>
                                    </Accordion>

                                    <Flex justifyContent='end' mt='5' bg='white' w='100%' position='fixed' bottom='0' p='3'>
                                        <Button
                                            mr='10'
                                            size='sm'
                                            className='General'
                                            h=''
                                            border='2px solid #002EFF'
                                            py='2.5'
                                            px='10'
                                            borderRadius='30px'
                                            color='white'
                                            bg='#002EFF'
                                            _hover={{ color: '#002EFF', bg: 'transparent' }}
                                            onClick={() => { onClose(); openSlide(false, dataPlanDrawer) }}
                                        >
                                            Lo quiero
                                        </Button>
                                    </Flex>
                                </>
                        }
                    </DrawerBody>
                </DrawerContent>
            </Drawer>

            {/* Abrir modal */}
            {
                openSlideModal &&
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal
                        setOpenSlideModal={setOpenSlideModal}
                        priceTyc={precioNormalSolicitado}
                        openSlideModal={openSlideModal}
                        descuento={descuentoPlan}
                        price={precioSolicitada}
                        valuePhoneInitial={''}
                        typePlan={typePlan}
                        plan={planSolicitada}
                        namePlan={namePlan}
                        submitInitial={false}
                        seccion="Hogar"
                        typePlanSelected={seccionView}
                        view={isBanner ? 'banner' : 'plan'}
                        id={id}
                    />
                </Box>
            }
        </Box>
    )
}


export default Hogar;